export default {
  translation: {
    // Common
    "app.name": "Give Protocol",
    "app.tagline": "بنية تحتية شفافة وبلا حدود للعطاء.",
    "common.skipToMainContent": "الانتقال إلى المحتوى الرئيسي",
    "common.cancel": "إلغاء",
    "common.edit": "تعديل",
    "common.delete": "حذف",
    "common.creating": "جارٍ الإنشاء...",
    "common.unknown": "غير معروف",
    "common.notAvailable": "غ/م",

    // Navigation
    "nav.browse": "تصفح المؤسسات الخيرية",
    "nav.opportunities": "فرص التطوع",
    "nav.contributions": "متتبع المساهمات",
    "nav.governance": "الحوكمة",
    "nav.dashboard": "لوحة العطاء",
    "nav.about": "حول",
    "nav.docs": "الوثائق",
    "nav.legal": "المعلومات القانونية",
    "nav.launchApp": "تشغيل التطبيق",

    // FAQ page (GIV-988)
    "faq.title": "الأسئلة الشائعة",
    "faq.subtitle":
      "كل ما تحتاج معرفته عن التبرع والعمل التطوعي وشفافية البلوك تشين.",

    // Settings
    "settings.title": "الإعدادات",
    "settings.language": "اللغة",
    "settings.currency": "العملة",

    // Auth
    "auth.login": "تسجيل الدخول",
    "auth.register": "إنشاء حساب",
    "auth.logout": "تسجيل الخروج",
    "auth.forgotPassword": "نسيت كلمة المرور؟",

    // Dashboard
    "dashboard.title": "لوحة العطاء",
    "dashboard.subtitle": "تتبع تبرعاتك ومساهماتك التطوعية",
    "dashboard.totalDonations": "إجمالي التبرعات",
    "dashboard.volunteerHours": "ساعات التطوع",
    "dashboard.skillsEndorsed": "المهارات المُعتمَدة",
    "dashboard.contributions": "المساهمات",
    "dashboard.yourTotalDonated": "إجمالي تبرعاتك",
    "dashboard.yourVolunteerHours": "ساعات تطوعك",
    "dashboard.yourSkillsEndorsed": "مهاراتك المُعتمَدة",
    "dashboard.impactGrowth": "نمو الأثر",
    "dashboard.charitiesSupported": "المؤسسات المدعومة",

    // Charity
    "charity.dashboard": "لوحة تحكم المؤسسة الخيرية",
    "charity.subtitle": "إدارة التبرعات وبرامج التطوع",
    "charity.activeVolunteers": "المتطوعون النشطون",
    "charity.transactions": "المعاملات",
    "charity.volunteers": "ساعات التطوع",
    "charity.applications": "الطلبات",
    "charity.totalReceived": "إجمالي المُستلَم",
    "charity.equityPoolValue": "قيمة مجمع حقوق الملكية",
    "charity.availableBalance": "الرصيد المتاح",

    // Contributions
    "contributions.date": "التاريخ",
    "contributions.type": "النوع",
    "contributions.organization": "المؤسسة",
    "contributions.details": "التفاصيل",
    "contributions.status": "الحالة",
    "contributions.verification": "التحقق",
    "contributions.export": "تصدير CSV",

    // Volunteer
    "volunteer.opportunities": "فرص التطوع",
    "volunteer.searchOpportunities": "البحث عن فرص...",
    "volunteer.selectSkill": "اختر مهارة",
    "volunteer.selectType": "اختر نوعًا",
    "volunteer.selectLanguage": "اختر لغة",
    "volunteer.allSkills": "جميع المهارات",
    "volunteer.allTypes": "جميع الأنواع",
    "volunteer.allLanguages": "جميع اللغات",
    "volunteer.applyNow": "تقدّم الآن",
    "volunteer.noOpportunitiesFound": "لم يتم العثور على فرص تطابق معاييرك.",
    "volunteer.verify": "التحقق من الساعات",
    "volunteer.verifying": "جارٍ التحقق...",
    "volunteer.reject": "رفض",
    "volunteer.accept": "قبول",
    "volunteer.processing": "جارٍ المعالجة...",
    "volunteer.hours": "ساعات في",
    "volunteer.description": "الوصف",
    "volunteer.appliedFor": "تقدّم لـ",
    "volunteer.verificationComplete": "اكتمل التحقق",
    "volunteer.hoursVerified":
      "تم التحقق من ساعات التطوع وتسجيلها على سلسلة الكتل.",
    "volunteer.verificationHash": "رمز التحقق",
    "volunteer.applicationAccepted": "تم قبول الطلب",
    "volunteer.applicationRecorded":
      "تم قبول طلب التطوع وتسجيله على سلسلة الكتل.",
    "volunteer.acceptanceHash": "رمز القبول",
    "volunteer.pendingHours": "ساعات التطوع المعلقة",
    "volunteer.noPendingHours": "لا توجد ساعات تطوع معلقة للتحقق منها.",
    "volunteer.pendingApplications": "الطلبات المعلقة",
    "volunteer.noPendingApplications": "لا توجد طلبات معلقة للمراجعة.",
    "volunteer.createOpportunity": "إنشاء فرصة تطوع",
    "volunteer.createNew": "إنشاء جديد",
    "volunteer.noOpportunitiesYet":
      'لم يتم إنشاء فرص بعد. انقر على "إنشاء جديد" للبدء.',
    "volunteer.opportunityTitle": "عنوان الفرصة",
    "volunteer.skills": "المهارات (مفصولة بفواصل)",
    "volunteer.commitment": "الالتزام",
    "volunteer.location": "الموقع",
    "volunteer.type": "النوع",
    "volunteer.workLanguage": "لغة العمل",
    "volunteer.status": "الحالة",

    // Volunteer commitment types
    "volunteer.commitment.oneTime": "مرة واحدة",
    "volunteer.commitment.shortTerm": "قصير المدى",
    "volunteer.commitment.longTerm": "طويل المدى",

    // Volunteer types
    "volunteer.type.remote": "عن بُعد",
    "volunteer.type.onsite": "في الموقع",
    "volunteer.type.hybrid": "مختلط",
    "volunteer.type.onSite": "في الموقع",

    // Volunteer - Opportunities page
    "volunteer.workTypeFilter": "تصفية نوع العمل",
    "volunteer.searchLocation": "المدينة أو المنطقة...",
    "volunteer.searchLocationAria": "البحث عن موقع",
    "volunteer.filter.skill": "المهارة: {{value}}",
    "volunteer.filter.type": "النوع: {{value}}",
    "volunteer.filter.language": "اللغة: {{value}}",
    "volunteer.filter.location": "الموقع: {{value}}",
    "volunteer.loadingOpportunities": "جارٍ تحميل الفرص...",
    "volunteer.loadOpportunitiesError": "تعذّر تحميل فرص التطوع. يرجى المحاولة مرة أخرى لاحقًا.",
    "volunteer.viewDetails": "عرض التفاصيل",
    "volunteer.backToOpportunities": "العودة إلى الفرص",
    "volunteer.detail.about": "حول هذه الفرصة",
    "volunteer.detail.skills": "المهارات المطلوبة",
    "volunteer.detail.commitment": "الالتزام الزمني",
    "volunteer.detail.location": "الموقع",
    "volunteer.detail.language": "اللغة",
    "volunteer.detail.hostedBy": "تستضيفها",
    "volunteer.detail.ongoing": "مستمرة",
    "volunteer.detail.applicationsClosed": "انتهى التقديم",
    "volunteer.detail.notFoundTitle": "لم يتم العثور على الفرصة",
    "volunteer.detail.notFoundMessage": "ربما اكتملت هذه الفرصة أو أُزيلت.",
    "volunteer.field.requirements": "المتطلبات",
    "volunteer.field.benefits": "المزايا",
    "volunteer.field.schedule": "الجدول الزمني",
    "volunteer.field.schedulePlaceholder": "مثال: الثلاثاء 6-8 مساءً، عطلات نهاية الأسبوع مرنة",
    "volunteer.field.startDate": "تاريخ البدء",
    "volunteer.field.endDate": "تاريخ الانتهاء",
    "volunteer.field.endDateHelp": "اتركه فارغًا إذا كانت مستمرة",
    "volunteer.field.applicationDeadline": "الموعد النهائي للتقديم",
    "volunteer.field.volunteersNeeded": "عدد المتطوعين المطلوب",
    "volunteer.field.minimumAge": "الحد الأدنى للعمر",
    "volunteer.field.backgroundCheckRequired": "التحقق من الخلفية مطلوب",
    "volunteer.field.trainingProvided": "التدريب متاح",
    "volunteer.field.onePerLine": "عنصر واحد في كل سطر",
    "volunteer.validation.volunteersNeeded": "أدخل رقمًا يساوي 1 أو أكثر",
    "volunteer.validation.minimumAge": "أدخل عمرًا بين 0 و120",
    "volunteer.validation.endDate": "يجب ألا يسبق تاريخ الانتهاء تاريخ البدء",
    "volunteer.signInToApply": "يرجى تسجيل الدخول للتقدم لفرص التطوع",
    "volunteer.applicationSuccess": "تم تقديم الطلب بنجاح!",
    "volunteer.removeFilter": "إزالة تصفية {{filter}}",

    // Volunteer - OpportunityForm
    "volunteer.validation.titleRequired": "العنوان مطلوب",
    "volunteer.validation.descriptionRequired": "الوصف مطلوب",
    "volunteer.validation.skillsRequired": "مهارة واحدة على الأقل مطلوبة",
    "volunteer.validation.locationRequired": "الموقع مطلوب",
    "volunteer.profileNotFound": "لم يتم العثور على ملف المستخدم",
    "volunteer.correctErrors": "يرجى تصحيح أخطاء التحقق",
    "volunteer.createFailed": "فشل إنشاء الفرصة",
    "volunteer.descriptionPlaceholder": "صِف فرصة التطوع بالتفصيل...",
    "volunteer.skillsPlaceholder": "مثال: تطوير الويب، إدارة المشاريع، الترجمة",
    "volunteer.locationPlaceholder": "مثال: عن بُعد، نيويورك، برلين",
    "volunteer.headerImage": "صورة الرأس",
    "volunteer.headerImageHelp": "ارفع صورة لعرضها في أعلى قائمة الفرصة",
    "volunteer.limitReached": "تم الوصول إلى حد الفرص",
    "volunteer.limitReachedMessage":
      "لقد وصلت إلى الحد الأقصى البالغ {{max}} فرصة تطوع نشطة. يرجى إغلاق أو إكمال فرصة حالية قبل إنشاء فرصة جديدة.",
    "volunteer.opportunityCount": "لديك {{count}} من أصل {{max}} فرصة نشطة.",

    // Volunteer - HoursVerificationTab
    "volunteer.hoursVerification": "التحقق من الساعات",
    "volunteer.hoursVerificationDescription":
      "مراجعة والتحقق من طلبات ساعات التطوع المقدمة",
    "volunteer.formalHours": "الساعات المسجلة",
    "volunteer.selfReported": "مُبلَّغ ذاتيًا",
    "volunteer.loggedHours": "ساعات التطوع المسجلة",
    "volunteer.loggedHoursDescription":
      "الساعات المسجلة من قبل المتطوعين عبر فرصك",
    "volunteer.allCaughtUp": "تم الانتهاء من الكل!",
    "volunteer.noPendingLoggedHours": "لا توجد ساعات مسجلة معلقة للتحقق منها.",
    "volunteer.selfReportedHours": "الساعات المُبلَّغة ذاتيًا",

    // Volunteer - OpportunitiesTab
    "volunteer.noOpportunitiesTitle": "لا توجد فرص بعد",
    "volunteer.activeCount": "{{count}} من أصل {{max}} فرصة نشطة",
    "volunteer.moreSkills": "+{{count}} إضافية",

    // Volunteer - ApplicationsTab
    "volunteer.noApplications": "لا توجد طلبات معلقة",
    "volunteer.unknownOpportunity": "فرصة غير معروفة",

    // Volunteer - VerificationLookup
    "volunteer.verifyContribution": "التحقق من مساهمة التطوع",
    "volunteer.hashPlaceholder": "أدخل رمز التحقق",
    "volunteer.searching": "جارٍ البحث...",
    "volunteer.verifyHash": "التحقق من الرمز",
    "volunteer.verificationNotFound": "لم يتم العثور على التحقق",
    "volunteer.verificationNotFoundMessage":
      "لم يتم العثور على الرمز الذي أدخلته في سجلاتنا. يرجى التحقق من الرمز والمحاولة مجددًا.",
    "volunteer.unknownOrganization": "مؤسسة غير معروفة",

    // Volunteer - VolunteerVerificationCard
    "volunteer.contributionVerification": "التحقق من مساهمة التطوع",
    "volunteer.volunteerLabel": "المتطوع",
    "volunteer.opportunityLabel": "الفرصة",
    "volunteer.organizationLabel": "المؤسسة",
    "volunteer.acceptedOn": "تاريخ القبول",
    "volunteer.verifiedOn": "تاريخ التحقق",
    "volunteer.verificationHashes": "رموز التحقق",
    "volunteer.blockchainReference": "مرجع سلسلة الكتل",

    // Volunteer - VerifyContribution page
    "volunteer.verifyingContribution": "جارٍ التحقق من المساهمة\u2026",
    "volunteer.noHashProvided": "لم يتم تقديم رمز تحقق.",
    "volunteer.verificationSuccessful": "تم التحقق بنجاح",
    "volunteer.contributionVerifiedBlockchain":
      "تم التحقق من هذه المساهمة التطوعية وتسجيلها على سلسلة الكتل.",
    "volunteer.verificationFailed": "فشل التحقق",
    "volunteer.hashNotFound":
      "لم يتم العثور على رمز التحقق {{hash}} أو أنه غير صالح.",

    // Volunteer - SelfReportedHoursDashboard
    "volunteer.volunteerHoursTitle": "ساعات التطوع",
    "volunteer.aboutSelfReported": "حول الساعات المُبلَّغة ذاتيًا",
    "volunteer.selfReportedInfo":
      "فقط الساعات المُصادق عليها من قبل مؤسسات موثقة تُحتسب في تصنيفات الأثر العالمي. يمكن تتبع الساعات للمؤسسات غير الموجودة على منصتنا لكنها ستُصنَّف كـ \u201cغير مُصادق عليها\u201d حتى يتم التصديق.",
    "volunteer.logHoursButton": "تسجيل الساعات",
    "volunteer.logVolunteerHours": "تسجيل ساعات التطوع",
    "volunteer.editRecord": "تعديل السجل",
    "volunteer.recordDetails": "تفاصيل السجل",
    "volunteer.backToList": "العودة إلى القائمة",
    "volunteer.deleteRecord": "حذف السجل؟",
    "volunteer.deleteConfirmation":
      "هل أنت متأكد أنك تريد حذف سجل ساعات التطوع هذا؟ لا يمكن التراجع عن هذا الإجراء.",

    // Volunteer - SelfReportedHoursForm
    "volunteer.activityType": "نوع النشاط",
    "volunteer.organization": "المؤسسة",
    "volunteer.searchRegistry": "البحث في السجل",
    "volunteer.searchRegistryPlaceholder":
      "البحث في سجل المؤسسات الخيرية بالاسم أو الرقم الضريبي…",
    "volunteer.registryTaxId": "الرقم الضريبي {{value}}",
    "volunteer.notListed": "غير مدرجة",
    "volunteer.organizationName": "اسم المؤسسة",
    "volunteer.enterOrgName": "أدخل اسم المؤسسة",
    "volunteer.contactEmail": "البريد الإلكتروني للتواصل",
    "volunteer.contactEmailOptional": "(اختياري)",
    "volunteer.onboardHelp": "قد نتواصل للمساعدة في ضم هذه المؤسسة",
    "volunteer.submittedForValidation": "سيتم تقديم هذا السجل للتصديق",
    "volunteer.submittedForValidationTo":
      "سيتم تقديم هذا السجل للتصديق إلى {{org}}",
    "volunteer.validationExpired": "انتهت فترة التصديق لهذا التاريخ",
    "volunteer.savedAsUnvalidated": "سيتم حفظ هذا السجل بدون تصديق",
    "volunteer.describeActivities": "صِف الأنشطة التي قمت بها...",
    "volunteer.moreCharsNeeded": "مطلوب {{count}} حرف إضافي",
    "volunteer.updating": "جارٍ التحديث...",
    "volunteer.logging": "جارٍ التسجيل...",
    "volunteer.updateHours": "تحديث الساعات",

    // Volunteer - SelfReportedHoursList
    "volunteer.statusFilter": "الحالة",
    "volunteer.activityTypeFilter": "نوع النشاط",
    "volunteer.filterFrom": "من",
    "volunteer.filterTo": "إلى",
    "volunteer.clearFilters": "مسح التصفية",
    "volunteer.allStatuses": "الكل",
    "volunteer.allActivityTypes": "جميع الأنواع",
    "volunteer.noMatchingRecords": "لا توجد سجلات مطابقة",
    "volunteer.noHoursLogged": "لم يتم تسجيل ساعات تطوع بعد",
    "volunteer.adjustFilters": "جرّب تعديل معايير التصفية للعثور على سجلات.",
    "volunteer.startLogging": "ابدأ بتسجيل ساعات تطوعك الأولى.",

    // Volunteer - SelfReportedHoursStats
    "volunteer.validatedHours": "الساعات المُصادق عليها",
    "volunteer.pendingValidation": "بانتظار التصديق",
    "volunteer.unvalidatedHours": "الساعات غير المُصادق عليها",
    "volunteer.rejectedLabel": "مرفوض",
    "volunteer.hoursUnit": "س",
    "volunteer.recordSingular": "سجل",
    "volunteer.recordPlural": "سجلات",

    // Volunteer - VolunteerApplicationForm
    "volunteer.applicationTitle": "طلب فرصة تطوع",
    "volunteer.applicationSubtitle":
      "ساعد في إحداث أثر مستدام من خلال مساهمات موثقة",
    "volunteer.progress.info": "معلومات",
    "volunteer.progress.skills": "مهارات",
    "volunteer.progress.consent": "موافقة",
    "volunteer.fieldValid": "يبدو جيدًا",
    "volunteer.draftSaved": "تم حفظ المسودة",
    "volunteer.personalInfo": "المعلومات الشخصية",
    "volunteer.firstName": "الاسم الأول",
    "volunteer.lastName": "اسم العائلة",
    "volunteer.emailAddress": "البريد الإلكتروني",
    "volunteer.phoneNumber": "رقم الهاتف",
    "volunteer.locationCity": "الموقع/المدينة",
    "volunteer.locationCityPlaceholder":
      "مثال: الرياض، المملكة العربية السعودية",
    "volunteer.timeZone": "المنطقة الزمنية",
    "volunteer.selectTimeZone": "اختر المنطقة الزمنية",
    "volunteer.ageRange": "الفئة العمرية",
    "volunteer.selectAgeRange": "اختر الفئة العمرية",
    "volunteer.skillsAndInterests": "المهارات والاهتمامات",
    "volunteer.skillsLabel": "المهارات ومجالات الاهتمام",
    "volunteer.skillPlaceholderFull":
      "ابدأ بكتابة مهاراتك (مثال: برمجة بايثون، الخطابة العامة، كتابة المنح)",
    "volunteer.skillPlaceholderShort": "اكتب مهارة واضغط Enter...",
    "volunteer.commitmentLevel": "مستوى الالتزام",
    "volunteer.commitmentOneTimeDesc": "مشروع واحد أو مهام قصيرة المدة",
    "volunteer.commitmentShortTermDesc": "من بضعة أسابيع إلى بضعة أشهر",
    "volunteer.commitmentLongTermDesc": "التزام مستمر لعدة أشهر أو أكثر",
    "volunteer.experienceLabel": "حدّثنا عن خبرتك ذات الصلة",
    "volunteer.experiencePlaceholder":
      "صِف خلفيتك ومهاراتك وما يحفزك للتطوع مع Give Protocol...",
    "volunteer.consentTitle": "الموافقة والاتفاقية",
    "volunteer.consentHeader": "موافقة طلب التطوع",
    "volunteer.submitting": "جارٍ الإرسال...",
    "volunteer.submitApplication": "تقديم طلب التطوع",
    "volunteer.disclaimerText":
      "بتقديم هذا الطلب، فإنك تُقرّ بأنك قرأت وفهمت سياسة الخصوصية وإرشادات التطوع الخاصة بـ Give Protocol. سيتم معالجة بياناتك وفقًا لأنظمة حماية البيانات المعمول بها.",
    "volunteer.validation.firstNameInvalid": "يرجى إدخال اسم أول صالح",
    "volunteer.validation.lastNameInvalid": "يرجى إدخال اسم عائلة صالح",
    "volunteer.validation.emailInvalid": "يرجى إدخال بريد إلكتروني صالح",
    "volunteer.validation.phoneInvalid": "يرجى إدخال رقم هاتف صالح",
    "volunteer.validation.experienceRequired": "يرجى وصف خبرتك ذات الصلة",
    "volunteer.validation.addSkill": "يرجى إضافة مهارة واحدة على الأقل",
    "volunteer.validation.ageRangeRequired": "يرجى اختيار فئتك العمرية",
    "volunteer.validation.consentRequired":
      "يجب الموافقة على جميع عناصر الموافقة المطلوبة",
    "volunteer.signInToSubmit": "يرجى تسجيل الدخول لتقديم الطلب",
    "volunteer.submitFailed": "فشل تقديم الطلب. يرجى المحاولة مجددًا.",

    // Volunteer - ApplicationForm
    "volunteer.applyForTitle": "التقدم لـ: {{title}}",
    "volunteer.fullName": "الاسم الكامل *",
    "volunteer.phoneRequired": "رقم الهاتف *",
    "volunteer.emailRequired": "البريد الإلكتروني *",
    "volunteer.dateOfBirth": "تاريخ الميلاد",
    "volunteer.availabilityTitle": "التوفر",
    "volunteer.preferredDays": "الأيام المفضلة",
    "volunteer.preferredTimes": "الأوقات المفضلة",
    "volunteer.commitmentLevelLabel": "مستوى الالتزام",
    "volunteer.skillsAndExperience": "المهارات والخبرة",
    "volunteer.relevantExperience": "الخبرة ذات الصلة *",
    "volunteer.certifications": "الشهادات (مفصولة بفواصل)",
    "volunteer.interestsAndPreferences": "الاهتمامات والتفضيلات",
    "volunteer.areasOfInterest": "مجالات الاهتمام (مفصولة بفواصل)",
    "volunteer.referencesTitle": "المراجع",
    "volunteer.referenceName": "اسم المرجع {{index}}",
    "volunteer.referenceContact": "جهة اتصال المرجع {{index}}",
    "volunteer.workSamplesTitle": "نماذج الأعمال",
    "volunteer.workSamplesLabel": "روابط نماذج الأعمال (مفصولة بفواصل)",
    "volunteer.submitApplicationShort": "تقديم الطلب",
    "volunteer.validation.nameInvalid": "يرجى إدخال اسم صالح (٢-١٠٠ حرف)",
    "volunteer.validation.provideExperience": "يرجى تقديم معلومات عن خبرتك",
    "volunteer.validation.selectDay": "يرجى اختيار يوم واحد على الأقل",
    "volunteer.validation.selectTime": "يرجى اختيار وقت واحد على الأقل",

    // Volunteer - ConsentForm
    "volunteer.consentUnderstand": "أفهم أن:",
    "volunteer.processingAckTitle": "الإقرار بالمعالجة",
    "volunteer.processingAckDesc":
      "يرجى مراجعة ما يلي والإقرار به قبل المتابعة:",
    "volunteer.essentialProcessingTitle": "معالجة الطلب (يجب التأكيد):",
    "volunteer.acknowledgmentTitle": "الإقرار",
    "volunteer.ageConfirmationTitle": "تأكيد العمر:",
    "volunteer.privacyNoticeTitle": "إشعار الخصوصية:",
    "volunteer.doNotAccept": "عدم الموافقة",
    "volunteer.acceptAndContinue": "الموافقة والمتابعة",
    "volunteer.validation.essentialRequired":
      "يجب تأكيد إقرار معالجة الطلب للمتابعة",
    "volunteer.validation.agePrivacyRequired":
      "يجب تأكيد عمرك والإقرار بأنك قرأت إشعار الخصوصية",

    // Age affirmation gate (shared across all surfaces — GIV-453)
    "ageGate.positive": "أؤكد أن عمري 16 عامًا أو أكثر.",
    "ageGate.negative":
      "بروتوكول Give متاح للمستخدمين الذين تبلغ أعمارهم 16 عامًا أو أكثر. إذا كان عمرك أقل من 16 عامًا، فلا يمكننا معالجة طلبك في هذا الوقت.",

    // Languages
    "language.english": "الإنجليزية",
    "language.spanish": "الإسبانية",
    "language.german": "الألمانية",
    "language.french": "الفرنسية",
    "language.japanese": "اليابانية",
    "language.chinese_simplified": "الصينية (المبسطة)",
    "language.chinese_traditional": "الصينية (التقليدية)",
    "language.thai": "التايلاندية",
    "language.vietnamese": "الفيتنامية",
    "language.korean": "الكورية",
    "language.arabic": "العربية",
    "language.hindi": "الهندية",
    "language.multiple": "لغات متعددة",

    // Contribution types
    "contribution.type.donation": "تبرع",
    "contribution.type.volunteerapplication": "طلب تطوع",
    "contribution.type.volunteerhours": "ساعات تطوع",
    "contribution.type.volunteeracceptance": "قبول تطوع",
    "contribution.type.volunteerverification": "التحقق من التطوع",

    // Donor/Volunteer
    "donor.volunteer": "متبرع/متطوع",
    "donor.anonymous": "مجهول",
    "volunteer.unknown": "متطوع غير معروف",

    // Statuses
    "status.completed": "مكتمل",
    "status.pending": "قيد الانتظار",
    "status.failed": "فشل",

    // Blockchain
    "blockchain.block": "الكتلة",

    // Filter
    "filter.allYears": "جميع السنوات",
    "filter.allTypes": "جميع الأنواع",
    "filter.donations": "التبرعات",
    "filter.volunteerApplications": "طلبات التطوع",
    "filter.volunteerHours": "ساعات التطوع",
    "filter.fiatDonations": "التبرعات النقدية",

    // Export
    "export.title": "تصدير بيانات المساهمة",
    "export.filename": "اسم الملف",
    "export.dateRange": "نطاق التاريخ",
    "export.includePersonal": "تضمين عناوين المحافظ",
    "export.willInclude": "سيتضمن التصدير:",
    "export.walletAddresses": "عناوين المحافظ (المرسل والمستلم)",
    "export.volunteerDetails": "تفاصيل المساهمة التطوعية (عند الاقتضاء)",
    "export.verificationHashes": "رموز التحقق (عند الاقتضاء)",
    "export.cancel": "إلغاء",
    "export.download": "تصدير CSV",

    // Skills
    "skills.endorsements": "المهارات والتزكيات",

    // Home
    "home.subtitle": "ربط الموارد بالقضايا الأكثر احتياجًا إليها",
    "home.startDonating": "ابدأ بالتبرع",

    // Modal - shared
    "modal.close": "إغلاق النافذة",
    "modal.closeAriaLabel": "إغلاق",

    // Modal - wallet connection
    "modal.wallet.title": "ربط محفظتك",
    "modal.wallet.description": "اربط محفظة لفتح جميع ميزات Give Protocol",
    "modal.wallet.benefit1": "تتبع تبرعاتك بشفافية على سلسلة الكتل",
    "modal.wallet.benefit2": "احصل على رموز GIVE كمكافآت لمساهماتك",
    "modal.wallet.benefit3": "شارك في قرارات الحوكمة الخاصة بالبروتوكول",
    "modal.wallet.connecting": "جارٍ الاتصال...",
    "modal.wallet.clickToConnect": "انقر للاتصال",
    "modal.wallet.noExtension": "لم يتم اكتشاف إضافة محفظة.",
    "modal.wallet.installMetaMask": "ثبّت MetaMask للبدء",
    "modal.wallet.skip": "تخطي في الوقت الحالي",
    "modal.wallet.footerNote": "يمكنك ربط محفظتك في أي وقت من شريط التنقل",
    "modal.wallet.failedConnect": "فشل الاتصال بالمحفظة",

    // Modal - wallet link
    "modal.walletLink.title": "ربط محفظتك",
    "modal.walletLink.description":
      "اربط محفظة بحسابك للتبرعات على السلسلة، ومكافآت الرموز، والحوكمة",
    "modal.walletLink.benefit1":
      "تبرع بالعملات الرقمية مباشرة للمؤسسات الخيرية الموثقة على السلسلة",
    "modal.walletLink.benefit2Pre": "طوّر",
    "modal.walletLink.benefit2Post": "أوراق اعتماد لمساهماتك",
    "modal.walletLink.benefit3":
      "سجّل الدخول بالبريد الإلكتروني أو المحفظة — نفس الحساب",
    "modal.walletLink.buttonLinking": "جارٍ الربط\u2026",
    "modal.walletLink.buttonLink": "ربط المحفظة",
    "modal.walletLink.buttonConnectFirst": "اتصل بالمحفظة أولًا",
    "modal.walletLink.footerNote": "يمكنك ربط محفظتك في أي وقت من الإعدادات",
    "modal.walletLink.failedLink": "فشل ربط المحفظة",

    // Modal - chain selection
    "modal.chain.title": "مرحبًا بك في Give Protocol",
    "modal.chain.subtitle": "اختر شبكتك المفضلة للبدء",
    "modal.chain.footerNote": "يمكنك تبديل الشبكات في أي وقت من القائمة",
    "modal.chain.connecting": "جارٍ الاتصال...",
    "modal.chain.continue": "متابعة",
    "modal.chain.failedSelect": "فشل اختيار الشبكة",

    // Modal - network selection (WalletModal step 1)
    "modal.network.title": "اختيار الشبكة",
    "modal.network.nextStep": "الخطوة التالية: ربط المحفظة",
    "modal.network.learnMore": "اعرف المزيد عن اختيار الشبكة",

    // Modal - wallet connect (WalletModal step 2)
    "modal.connect.title": "ربط المحفظة",
    "modal.connect.backAria": "العودة إلى اختيار الشبكة",
    "modal.connect.noWallets": "لا توجد محافظ متاحة لسلاسل {{chainType}}.",
    "modal.connect.tryDifferentChain": "جرّب اختيار نوع سلسلة مختلف.",
    "modal.connect.viewOtherWallets": "عرض المحافظ الأخرى المدعومة",
    "modal.connect.termsAgreement": "بالاتصال، فإنك توافق على",
    "modal.connect.termsLink": "شروط الخدمة",
    "modal.connect.termsPrivacyConnector": "و",
    "modal.connect.privacyLink": "سياسة الخصوصية",
    "modal.connect.chainTypeAria": "نوع السلسلة",
    "modal.connect.failedConnect": "فشل الاتصال",

    // Modal - donation
    "modal.donation.successTitle": "شكرًا لك!",
    "modal.donation.donationProcessedOneTime":
      "تمت معالجة تبرعك بمبلغ {{amount}} لصالح {{charityName}}.",
    "modal.donation.donationProcessedRecurring":
      "تمت معالجة تبرعك الشهري بمبلغ {{amount}} لصالح {{charityName}}.",
    "modal.donation.recurringNote": "سيتم الخصم شهريًا حتى تقوم بالإلغاء.",
    "modal.donation.receiptNote": "تم إرسال إيصال إلى بريدك الإلكتروني.",
    "modal.donation.done": "تم",
    "modal.donation.errorTitle": "حدث خطأ ما",
    "modal.donation.errorDefault": "حدث خطأ غير متوقع. يرجى المحاولة مجددًا.",
    "modal.donation.tryAgain": "أعد المحاولة",
    "modal.donation.close": "إغلاق",
    "modal.donation.amountLabel": "مبلغ التبرع",
    "modal.donation.perMonth": "شهريًا",
    "modal.donation.monthly": "شهري",
    "modal.donation.oneTime": "مرة واحدة",
    "modal.donation.loadingPaymentForm": "جارٍ تحميل نموذج الدفع...",
    "modal.donation.supportMonthly": "ادعم {{charityName}} شهريًا",
    "modal.donation.donateToCharity": "تبرع لـ {{charityName}}",

    // Modal - scheduled donation
    "modal.scheduledDonation.title": "جدولة تبرعات شهرية لـ {{charityName}}",

    // Modal - withdrawal
    "modal.withdrawal.title": "طلب سحب",

    // Modal - validation response
    "modal.validation.rejectTitle": "رفض طلب التصديق",
    "modal.validation.reviewTitle": "مراجعة طلب التصديق",
    "modal.validation.volunteer": "المتطوع",
    "modal.validation.activityDetails": "تفاصيل النشاط",
    "modal.validation.date": "التاريخ",
    "modal.validation.hour": "ساعة",
    "modal.validation.hours": "ساعات",
    "modal.validation.activityType": "نوع النشاط",
    "modal.validation.location": "الموقع",
    "modal.validation.description": "الوصف",
    "modal.validation.submitted": "تم الإرسال:",
    "modal.validation.daysRemaining": "({{count}} أيام متبقية للتصديق)",
    "modal.validation.appealNote": "هذا استئناف/إعادة تقديم لطلب مرفوض سابقًا",
    "modal.validation.rejectPrompt":
      "يرجى اختيار سبب لرفض طلب التصديق هذا. سيتم إخطار المتطوع.",
    "modal.validation.reject": "رفض",
    "modal.validation.approve": "موافقة",
    "modal.validation.processing": "جارٍ المعالجة...",
    "modal.validation.back": "رجوع",
    "modal.validation.confirmRejection": "تأكيد الرفض",
    "modal.validation.selectReasonError": "يرجى اختيار سبب الرفض",

    // Toast
    "toast.dismiss": "إخفاء الإشعار",

    // Error boundary
    "error.somethingWrong": "حدث خطأ ما",
    "error.unexpectedError": "حدث خطأ غير متوقع",
    "error.tryAgain": "أعد المحاولة",
    "error.tooManyAttempts": "محاولات كثيرة جدًا",
    "error.goHome": "الذهاب إلى الصفحة الرئيسية",
    "error.details": "تفاصيل الخطأ",

    // Validation - rejection reason select
    "validation.rejection.reasonLabel": "سبب الرفض",
    "validation.rejection.reasonPlaceholder": "اختر سببًا...",
    "validation.rejection.notesLabel": "ملاحظات إضافية",
    "validation.rejection.optional": "(اختياري)",
    "validation.rejection.notesPlaceholder": "قدّم سياقًا إضافيًا للرفض...",

    // Validation - batch actions
    "validation.batch.deselectAll": "إلغاء تحديد الكل",
    "validation.batch.selectAll": "تحديد الكل",
    "validation.batch.selected": "{{selected}} من {{total}} محدد",
    "validation.batch.clear": "مسح",
    "validation.batch.reject": "رفض ({{count}})",
    "validation.batch.approve": "موافقة ({{count}})",

    // Dashboard - admin redirect (GIV-254)
    "dashboard.adminTitle": "لوحة تحكم المشرف",
    "dashboard.adminNote": "يرجى استخدام لوحة الإدارة لإدارة المنصة.",
    "dashboard.adminButton": "الذهاب إلى لوحة الإدارة",
    "dashboard.logVolunteerHours": "تسجيل ساعات التطوع",
    "dashboard.hideVolunteerHours": "إخفاء ساعات التطوع",
    "dashboard.viewMonthlyDonations": "عرض التبرعات الشهرية",
    "dashboard.hideMonthlyDonations": "إخفاء التبرعات الشهرية",
    "dashboard.walletSettings": "إعدادات المحفظة",
    "dashboard.overview": "نظرة عامة",
    "dashboard.lastUpdated": "آخر تحديث",
    "dashboard.refreshData": "تحديث البيانات",
    "dashboard.searchPlaceholder": "البحث عن مشاريع، متطوعين (Cmd+K)",
    "dashboard.search": "بحث",

    // Settings - account section (GIV-254)
    "settings.manageDescription": "إدارة حسابك وتفضيلاتك",
    "settings.account": "الحساب",
    "settings.email": "البريد الإلكتروني",
    "settings.displayName": "اسم العرض",
    "settings.authMethod": "طريقة المصادقة",
    "settings.role": "الدور",

    // Common additional (GIV-254)
    "common.refresh": "تحديث",
    "common.all": "الكل",
    "common.loading": "جارٍ التحميل...",
    "common.close": "إغلاق",
    "common.back": "رجوع",

    // Cause (GIV-254)
    "cause.createCause": "إنشاء قضية",

    // Contribution Tracker (GIV-254)
    "tracker.title": "تصنيفات الأثر العالمي",
    "tracker.subtitle": "تتبع والاحتفاء بالأثر الجماعي لمجتمعنا",
    "tracker.searchPlaceholder": "البحث عن المساهمين...",
    "tracker.exportCSV": "تصدير CSV",
    "tracker.exportPDF": "تصدير PDF",
    "tracker.hideContributions": "إخفاء مساهماتي من التصنيفات",
    "tracker.yourAlias": "اسمك المستعار:",
    "tracker.changeAlias": "تغيير",
    "tracker.setWalletAlias": "تعيين اسم مستعار للمحفظة",
    "tracker.aliasTitle": "تعيين اسم مستعار للمحفظة",
    "tracker.aliasDescription":
      "سيتم عرض اسمك المستعار في متتبع المساهمات بدلًا من عنوان محفظتك.",
    "tracker.aliasLabel": "الاسم المستعار",
    "tracker.aliasPlaceholder": "أدخل اسمك المستعار المفضل",
    "tracker.saveAlias": "حفظ الاسم المستعار",
    "tracker.donationRankings": "تصنيفات التبرعات",
    "tracker.volunteerRankings": "تصنيفات التطوع",
    "tracker.exportComplete": "اكتمل التصدير",
    "tracker.exportDonationCSV": "تم تصدير لوحة تصنيف التبرعات كـ CSV",
    "tracker.exportVolunteerCSV": "تم تصدير لوحة تصنيف التطوع كـ CSV",
    "tracker.exportPDFSuccess": "تم تصدير لوحة التصنيف كـ PDF",
    "tracker.exportFailed": "فشل التصدير",
    "tracker.exportNoData": "لا توجد بيانات متاحة للتصدير",
    "tracker.exportError": "حدث خطأ أثناء تصدير البيانات",
    "tracker.walletNotConnected": "المحفظة غير متصلة",
    "tracker.connectWalletForAlias": "يرجى ربط محفظتك لتعيين اسم مستعار",
    "tracker.invalidAlias": "اسم مستعار غير صالح",
    "tracker.enterValidAlias": "يرجى إدخال اسم مستعار صالح",

    // Charity Portal (GIV-254)
    "charity.portal.deleteTitle": "حذف {{type}}؟",
    "charity.portal.deleteDescription":
      "لا يمكن التراجع عن هذا الإجراء. سيتم حذف {{type}} نهائيًا.",
    "charity.portal.walletNotConfigured": "لم يتم تكوين محفظة الاستلام.",
    "charity.portal.walletDonationNote":
      "اربط محفظة لاستقبال التبرعات على السلسلة.",
    "charity.portal.setupWallet": "إعداد المحفظة",

    // Charity dashboard onboarding & verification
    "charity.onboarding.ariaLabel": "قائمة التهيئة",
    "charity.onboarding.title": "البدء",
    "charity.onboarding.progress": "اكتملت {{completed}} من {{total}} خطوات",
    "charity.onboarding.optional": "اختياري",
    "charity.onboarding.allComplete":
      "اكتملت جميع الخطوات! يمكنك إغلاق هذه القائمة.",
    "charity.onboarding.expand": "توسيع القائمة",
    "charity.onboarding.collapse": "طي القائمة",
    "charity.onboarding.dismiss": "إغلاق قائمة التهيئة",
    "charity.onboarding.check": "تحديد {{label}}",
    "charity.onboarding.uncheck": "إلغاء تحديد {{label}}",
    "charity.onboarding.stepDone": "{{label}} (مكتمل)",
    "charity.onboarding.stepAuto": "{{label}} (يكتمل تلقائيًا)",
    "charity.onboarding.goToOrganization": "الانتقال إلى المنظمة",
    "charity.onboarding.setupWallet": "إعداد المحفظة",
    "charity.onboarding.item.completeProfile.label": "إكمال ملف المنظمة",
    "charity.onboarding.item.completeProfile.description":
      "أضف اسم منظمتك ووصفها وعنوانها ومعلومات الاتصال.",
    "charity.onboarding.item.uploadLogo.label": "رفع الشعار أو صورة الغلاف",
    "charity.onboarding.item.uploadLogo.description":
      "أضف شعارًا أو صورة غلاف لمساعدة المتبرعين على التعرف على جمعيتك الخيرية.",
    "charity.onboarding.item.connectWallet.label": "إعداد محفظة الاستلام",
    "charity.onboarding.item.connectWallet.description":
      "اختر محفظة Safe متعددة التوقيعات أو حفظًا مؤسسيًا أو محفظة بتوقيع واحد لاستلام التبرعات. أثبت سيطرتك بتوقيع رسالة.",
    "charity.onboarding.item.bankDetails.label":
      "إعداد البيانات المصرفية للتحويل إلى العملة الورقية",
    "charity.onboarding.item.bankDetails.description":
      "قم بإعداد المعلومات المصرفية إذا كنت ترغب في قبول التبرعات بالبطاقات.",
    "charity.onboarding.item.acceptTerms.label":
      "مراجعة شروط الخدمة والموافقة عليها",
    "charity.onboarding.item.acceptTerms.description":
      "اقرأ شروط وأحكام Give Protocol الخاصة بالجمعيات الخيرية وأكّد موافقتك عليها.",
    "charity.verification.pendingTitle": "الطلب قيد المراجعة",
    "charity.verification.pendingBody":
      "يراجع فريقنا طلب جمعيتك الخيرية. يستغرق ذلك عادةً من 3 إلى 5 أيام عمل. سنرسل إليك بريدًا إلكترونيًا عند اتخاذ القرار.",
    "charity.verification.rejectedTitle": "لم تتم الموافقة على الطلب",
    "charity.verification.reason": "السبب: {{notes}}",
    "charity.verification.rejectedDefault":
      "لم تتم الموافقة على طلبك في الوقت الحالي.",
    "charity.verification.contactSupport": "التواصل مع الدعم",
    "charity.verification.suspendedTitle": "الحساب موقوف",
    "charity.verification.suspendedDefault": "تم إيقاف حساب جمعيتك الخيرية.",
    "charity.verification.appealSuspension": "الطعن في الإيقاف",
    "charity.verification.verifiedTitle": "تم التحقق من الجمعية الخيرية",
    "charity.verification.verifiedBody":
      "تم التحقق من منظمتك ويمكن للمتبرعين الآن دعم قضاياك.",
    "charity.portal.receivingWallet": "محفظة الاستلام: {{address}}",
    "charity.portal.loadError":
      "تعذر تحميل بيانات الجمعية الخيرية. يرجى المحاولة مرة أخرى.",

    // Timestamps (GIV-254)
    "timestamp.justNow": "الآن",
    "timestamp.oneMinuteAgo": "منذ دقيقة واحدة",
    "timestamp.minutesAgo": "منذ {{count}} دقائق",

    // Common additions (GIV-256)
    "common.previous": "السابق",
    "common.next": "التالي",
    "common.pageOfTotal": "صفحة {{page}} من {{total}}",
    "common.retry": "إعادة المحاولة",
    "common.processing": "جارٍ المعالجة...",
    "common.saving": "جارٍ الحفظ...",
    "common.donate": "تبرع",
    "common.active": "نشط",

    // Portfolio Funds - public page (GIV-256)
    "portfolio.donationType": "نوع التبرع",
    "portfolio.devNative": "DEV (أصلي)",
    "portfolio.testToken": "رمز TEST",
    "portfolio.donationAmount": "مبلغ التبرع:",
    "portfolio.platformFee": "رسوم المنصة ({{percentage}}%):",
    "portfolio.toCharities": "للمؤسسات الخيرية:",
    "portfolio.eachCharityReceives": "تتلقى كل مؤسسة خيرية:",
    "portfolio.donateToFund": "تبرع لـ {{name}}",
    "portfolio.equalDistribution": "توزيع متساوٍ",
    "portfolio.equalDistributionNote":
      "سيتم تقسيم تبرعك بالتساوي بين {{count}} مؤسسة خيرية موثقة.",
    "portfolio.eachCharityPercentage":
      "تتلقى كل مؤسسة خيرية {{percentage}}% من التبرعات",
    "portfolio.verifiedCharities": "{{count}} مؤسسة خيرية موثقة",
    "portfolio.donateToFundButton": "تبرع للصندوق",
    "portfolio.noFundsAvailable": "لا توجد صناديق محفظة متاحة",
    "portfolio.checkBackLater": "تحقق لاحقًا لمعرفة فرص التمويل الجديدة",
    "portfolio.amountLabel": "المبلغ ({{currency}})",
    "portfolio.invalidAmount": "يرجى إدخال مبلغ صالح",
    "portfolio.donationSuccess": "تم التبرع بنجاح!",
    "portfolio.donationFailed": "فشل التبرع. يرجى المحاولة مجددًا.",

    // Admin - Activity event type labels (GIV-256)
    "admin.activity.donation": "تبرع",
    "admin.activity.registration": "تسجيل",
    "admin.activity.verification": "تحقق",
    "admin.activity.volunteerHours": "ساعات تطوع",
    "admin.activity.default": "نشاط",

    // Admin - Dashboard page (GIV-256)
    "admin.dashboard.title": "لوحة تحكم المشرف",
    "admin.dashboard.alerts": "التنبيهات",
    "admin.dashboard.alertsPending": "{{count}} معلق",
    "admin.dashboard.alertsView": "عرض",
    "admin.dashboard.recentActivity": "النشاط الأخير",
    "admin.dashboard.noRecentActivity": "لا يوجد نشاط حديث.",
    "admin.dashboard.quickActions": "الإجراءات السريعة",
    "admin.dashboard.errorTitle": "خطأ في تحميل لوحة التحكم",
    "admin.stats.last7d": "آخر ٧ أيام",
    "admin.stats.last30d": "آخر ٣٠ يومًا",
    "admin.stats.totalDonors": "إجمالي المتبرعين",
    "admin.stats.newRegistrations": "تسجيلات جديدة",
    "admin.stats.charities": "المؤسسات الخيرية",
    "admin.stats.pendingVerification": "بانتظار التحقق",
    "admin.stats.verifiedCharities": "المؤسسات الخيرية الموثقة",
    "admin.stats.activeVolunteers": "المتطوعون النشطون",
    "admin.stats.totalDonationVolume": "إجمالي حجم التبرعات",
    "admin.stats.cryptoVolume": "حجم العملات الرقمية",
    "admin.stats.fiatVolume": "حجم العملات النقدية",
    "admin.stats.donations": "تبرعات",

    // Admin - Quick Actions (GIV-256)
    "admin.actions.viewReports": "عرض التقارير",
    "admin.actions.viewReportsDesc": "إنشاء تحليلات مفصلة",
    "admin.actions.manageCharities": "إدارة المؤسسات الخيرية",
    "admin.actions.manageCharitiesDesc": "مراجعة واعتماد المؤسسات",
    "admin.actions.systemSettings": "إعدادات النظام",
    "admin.actions.systemSettingsDesc": "تكوين معاملات المنصة",
    "admin.actions.manageImpactMetrics": "إدارة مقاييس الأثر",
    "admin.actions.manageImpactMetricsDesc": "تكوين بيانات حاسبة الأثر",
    "admin.actions.donationMonitoring": "مراقبة التبرعات",
    "admin.actions.donationMonitoringDesc":
      "مراقبة التبرعات والإبلاغ عنها وإعداد التقارير",
    "admin.actions.contentModeration": "إدارة المحتوى",
    "admin.actions.contentModerationDesc":
      "إخفاء والإبلاغ عن ومراجعة الفرص والقضايا",
    "admin.actions.portfolioFunds": "صناديق المحفظة",
    "admin.actions.portfolioFundsDesc": "إنشاء وإدارة محافظ العطاء المنسقة",
    "admin.actions.charityRequests": "طلبات المؤسسات الخيرية",
    "admin.actions.charityRequestsDesc":
      "مراجعة طلبات المتبرعين للمؤسسات الخيرية غير المُطالب بها",

    // Admin - Portfolio Funds management page (GIV-256)
    "admin.portfolio.title": "صناديق المحفظة",
    "admin.portfolio.subtitle": "إنشاء وإدارة محافظ العطاء المنسقة",
    "admin.portfolio.newFund": "صندوق جديد",
    "admin.portfolio.editFund": "تعديل الصندوق",
    "admin.portfolio.createNewFund": "إنشاء صندوق جديد",
    "admin.portfolio.fundName": "اسم الصندوق",
    "admin.portfolio.fundNamePlaceholder": "مثال: صندوق الأثر البيئي",
    "admin.portfolio.description": "الوصف",
    "admin.portfolio.descriptionPlaceholder":
      "صِف غرض الصندوق وتركيزه على الأثر...",
    "admin.portfolio.category": "الفئة",
    "admin.portfolio.selectCategory": "اختر فئة",
    "admin.portfolio.imageUrl": "رابط الصورة",
    "admin.portfolio.imageUrlPlaceholder": "https://...",
    "admin.portfolio.selectCharities":
      "اختيار المؤسسات الخيرية ({{count}} محددة)",
    "admin.portfolio.noCharitiesFound": "لم يتم العثور على مؤسسات خيرية موثقة",
    "admin.portfolio.saving": "جارٍ الحفظ...",
    "admin.portfolio.createFund": "إنشاء الصندوق",
    "admin.portfolio.updateFund": "تحديث الصندوق",
    "admin.portfolio.noFundsYet": "لا توجد صناديق محفظة بعد",
    "admin.portfolio.noFundsMessage":
      "أنشئ صندوقك الأول لتجميع المؤسسات الخيرية للتبرعات المجمّعة",
    "admin.portfolio.charity": "مؤسسة خيرية",
    "admin.portfolio.charities": "مؤسسات خيرية",
    "admin.portfolio.createdOn": "أُنشئ {{date}}",
    "admin.portfolio.statusActive": "نشط",
    "admin.portfolio.statusPaused": "مُتوقف",
    "admin.portfolio.statusArchived": "مؤرشف",
    "admin.portfolio.errorLoad": "فشل تحميل البيانات",
    "admin.portfolio.errorArchive": "فشل أرشفة الصندوق",
    "admin.portfolio.fundArchived": "تمت أرشفة الصندوق",
    "admin.portfolio.fundUpdated": "تم تحديث الصندوق",
    "admin.portfolio.fundCreated": "تم إنشاء الصندوق",
    "admin.portfolio.errorSave": "فشل حفظ الصندوق",

    // Admin - Charity Management page (GIV-256)
    "admin.charity.title": "إدارة المؤسسات الخيرية",
    "admin.charity.totalCount": "{{count}} إجمالي",
    "admin.charity.allStatuses": "جميع الحالات",
    "admin.charity.searchPlaceholder": "البحث بالاسم\u2026",
    "admin.charity.colName": "الاسم",
    "admin.charity.colEin": "الرقم الضريبي",
    "admin.charity.taxIdDisplay": "الرقم الضريبي {{value}}",
    "admin.charity.searchByNameEin": "البحث بالاسم أو الرقم الضريبي…",
    "admin.charity.colCategory": "الفئة",
    "admin.charity.colStatus": "الحالة",
    "admin.charity.colSigner": "جهة الاتصال",
    "admin.charity.colJoined": "تاريخ الانضمام",
    "admin.charity.colWallet": "المحفظة",
    "admin.charity.colActions": "الإجراءات",
    "admin.charity.walletNotSet": "غير محدد",
    "admin.charity.approve": "اعتماد",
    "admin.charity.reject": "رفض",
    "admin.charity.suspend": "تعليق",
    "admin.charity.reinstate": "إعادة تفعيل",
    "admin.charity.statusPending": "قيد الانتظار",
    "admin.charity.statusVerified": "موثق",
    "admin.charity.statusApproved": "معتمد",
    "admin.charity.statusRejected": "مرفوض",
    "admin.charity.statusSuspended": "معلق",
    "admin.charity.approveTitle": "اعتماد المؤسسة الخيرية",
    "admin.charity.rejectTitle": "رفض المؤسسة الخيرية",
    "admin.charity.suspendTitle": "تعليق المؤسسة الخيرية",
    "admin.charity.reinstateTitle": "إعادة تفعيل المؤسسة الخيرية",
    "admin.charity.confirmAction": "تأكيد الإجراء",
    "admin.charity.reasonRequired": "السبب (مطلوب)",
    "admin.charity.reasonOptional": "السبب (اختياري)",
    "admin.charity.saving": "جارٍ الحفظ\u2026",
    "admin.charity.confirm": "تأكيد",
    "admin.charity.noResults":
      "لم يتم العثور على مؤسسات خيرية تطابق معايير التصفية.",
    "admin.charity.unnamed": "منظمة بدون اسم",

    // Admin - Charity Requests page (GIV-256)
    "admin.charityRequests.title": "طلبات المؤسسات الخيرية",
    "admin.charityRequests.subtitle":
      "طلبات مقدمة من المتبرعين للمؤسسات الخيرية غير المُطالب بها، مجمّعة حسب المؤسسة. يجب إعطاء الأولوية للمؤسسات ذات الاهتمام الأعلى للتواصل.",
    "admin.charityRequests.ein": "الرقم الضريبي",
    "admin.charityRequests.requests": "الطلبات",
    "admin.charityRequests.latestRequester": "آخر مقدم طلب",
    "admin.charityRequests.latestRequest": "آخر طلب",
    "admin.charityRequests.firstRequest": "أول طلب",
    "admin.charityRequests.empty": "لم يتم تقديم أي طلبات مؤسسات خيرية بعد.",
    "admin.charityRequests.errorTitle": "خطأ في تحميل طلبات المؤسسات الخيرية",
    "admin.charityRequests.showing": "عرض {{shown}} من {{total}} مؤسسة فريدة.",

    // Admin - Volunteer Validation page (GIV-256)
    "admin.validation.title": "إشراف على تصديق التطوع",
    "admin.validation.totalCount": "{{count}} طلب إجمالي",
    "admin.validation.pipelineStats": "إحصائيات خط المعالجة",
    "admin.validation.noStats": "لا توجد إحصائيات متاحة.",
    "admin.validation.pending": "قيد الانتظار",
    "admin.validation.approved": "معتمد",
    "admin.validation.rejected": "مرفوض",
    "admin.validation.expired": "منتهي الصلاحية",
    "admin.validation.avgResponseTime": "متوسط وقت الاستجابة:",
    "admin.validation.expirationRate": "معدل انتهاء الصلاحية:",
    "admin.validation.rejectionRate": "معدل الرفض:",
    "admin.validation.searchPlaceholder": "البحث عن متطوع، مؤسسة\u2026",
    "admin.validation.requestsTab": "طلبات التصديق",
    "admin.validation.patternsTab": "الأنماط المشبوهة",
    "admin.validation.colVolunteer": "المتطوع",
    "admin.validation.colOrganisation": "المؤسسة",
    "admin.validation.colHours": "الساعات",
    "admin.validation.colActivityDate": "تاريخ النشاط",
    "admin.validation.colHrsPerWeek": "ساعات/أسبوع",
    "admin.validation.colTotalRequests": "إجمالي الطلبات",
    "admin.validation.override": "تجاوز",
    "admin.validation.noPatterns": "لم يتم اكتشاف أنماط مشبوهة.",
    "admin.validation.noRequests": "لم يتم العثور على طلبات تصديق.",
    "admin.validation.patternsDescription":
      "المتطوعون الذين تم تمييزهم للإبلاغ عن ساعات تتجاوز الحد المُعد خلال فترة ٧ أيام متحركة. قد تشير هذه الأنماط إلى إساءة استخدام نظام الساعات المُبلَّغة ذاتيًا.",
    "admin.validation.overrideTitle": "تجاوز طلب التصديق",
    "admin.validation.newStatus": "الحالة الجديدة",
    "admin.validation.reasonRequired": "السبب (مطلوب)",
    "admin.validation.reasonPlaceholder": "اشرح سبب تجاوز هذا الطلب\u2026",
    "admin.validation.saving": "جارٍ الحفظ\u2026",
    "admin.validation.confirmOverride": "تأكيد التجاوز",
    "admin.validation.allStatuses": "جميع الحالات",
    "admin.validation.colStatus": "الحالة",
    "admin.validation.colCreated": "تاريخ الإنشاء",

    // GIV-266: Delta translations (354 keys)
    "home.hero.title": "عطاء شفاف",
    "home.hero.titleAccent": "أثر مستدام",
    "home.hero.description":
      "عمل خيري شفاف بشكل جذري للعصر الرقمي. مصمم لتحقيق الأثر، مدعوم بتقنية قابلة للتحقق. كل مساهمة قابلة للتتبع من المتبرع إلى الوجهة.",
    "home.hero.visionTitle": "رؤيتنا",
    "home.hero.visionText":
      "يقوم Give Protocol ببناء مستقبل العطاء عالي النزاهة. نستفيد من البنية التحتية التقنية المتقدمة لسد الفجوة بين رأس المال العالمي والأثر المحلي. من خلال دمج دعم الأصول الرقمية السلس مع أساليب العطاء التقليدية، نبني منظومات تمويل مرنة تحوّل التبرعات لمرة واحدة إلى محركات دائمة لدعم أهم القضايا في العالم.",
    "home.comingSoon": "قريبًا",
    "home.readDocs": "اقرأ الوثائق",
    "home.features.sectionTitle": "بوابتك إلى العمل الخيري الشفاف",
    "home.features.sectionSubtitle":
      "بنية تحتية متعددة السلاسل للعطاء السلس — عملات رقمية أو تقليدية — مع شفافية كاملة",
    "home.features.highEfficiency.title": "عطاء عالي الكفاءة",
    "home.features.highEfficiency.description":
      "ساهم مباشرة في المنظمات المعتمدة دون أي غموض. يوفر سجلنا الآلي تحققًا فوريًا، مما يضمن توجيه دعمك تمامًا حيث تدعو الحاجة.",
    "home.features.equityFunds.title": "صناديق الأسهم الخيرية",
    "home.features.equityFunds.description":
      "تجاوز التبرعات لمرة واحدة من خلال المساهمة في صناديق أسهم مُدارة بذكاء. نستخدم استراتيجيات رقمية متطورة منخفضة المخاطر لتحويل رأس مالك إلى تدفق تمويل دائم، يدعم المهام الخيرية للأجيال القادمة.",
    "home.features.impactFunds.title": "صناديق الأثر",
    "home.features.impactFunds.description":
      "اجمع الموارد لقضايا محددة. البيئة، التعليم، مكافحة الفقر — تبرعك يتضاعف من خلال العمل الجماعي.",
    "home.features.verifiedOrgs.title": "منظمات معتمدة",
    "home.features.verifiedOrgs.description":
      "تصفح أي منظمة مسجلة، أو ابحث عن شارة التحقق. المنظمات التي تشارك في عملية التدقيق لدينا تحصل على توثيق على السلسلة يثق به المتبرعون.",
    "home.features.blockchainVerified.title": "موثّق على البلوكتشين",
    "home.features.blockchainVerified.description":
      "رموز مرتبطة بالهوية تُكرّم مساهمات المتطوعين. المهارات والساعات والأثر — كلها مسجلة بشكل دائم على السلسلة.",
    "home.features.bridgingModes.title": "جسر بين أساليب العطاء",
    "home.features.bridgingModes.description":
      "سواء كنت تتبرع بالدولار الأمريكي أو بالأصول الرقمية، تضمن بنيتنا متعددة الشبكات أن مساهمتك تسير بسرعة العالم الحديث.",
    "home.roles.title": "مصمم لكل من يغيّر العالم",
    "home.roles.donors.title": "للمتبرعين",
    "home.roles.donors.item1": "تبرع بالعملات الرقمية أو التقليدية — اختيارك",
    "home.roles.donors.item2": "المشاركة في الحوكمة",
    "home.roles.donors.item3": "بناء سمعة على السلسلة",
    "home.roles.nonprofits.title": "للمنظمات غير الربحية",
    "home.roles.nonprofits.item1": "الوصول إلى شرائح جديدة من المتبرعين",
    "home.roles.nonprofits.item2": "تمويل مستدام عبر CEF",
    "home.roles.nonprofits.item3": "تقارير شفافية معززة",
    "home.roles.volunteers.title": "للمتطوعين",
    "home.roles.volunteers.item1": "سجلات مساهمات قابلة للتحقق",
    "home.roles.volunteers.item2": "شهادات مهارات محمولة (SBT)",
    "home.roles.volunteers.item3": "شارات إنجاز وتقدير",
    "home.impact.title": "صناديق الأثر المخطط لها",
    "home.impact.environmental.title": "صندوق الأثر البيئي",
    "home.impact.environmental.description":
      "دعم إعادة التشجير وتنظيف المحيطات ومبادرات الطاقة المتجددة. تبرعات مجمّعة موجهة إلى منظمات بيئية معتمدة تحقق أثرًا قابلًا للقياس.",
    "home.impact.education.title": "صندوق الفرص التعليمية",
    "home.impact.education.description":
      "تقديم المنح الدراسية وأدوات التعلم الرقمي وتدريب المعلمين. تمويل جماعي مضاعف لدعم المبادرات التعليمية في المجتمعات المحرومة.",
    "home.cta.title": "مستعد لتغيير مفهوم العطاء؟",
    "home.cta.subtitle":
      "كن من أوائل المستفيدين من العمل الخيري الشفاف المدعوم بتقنية البلوكتشين. انضم إلى مجتمعنا الذي يبني مستقبلًا أفضل للعطاء الخيري.",
    "home.cta.explore": "استكشف القضايا",
    "home.nav.features": "المزايا",
    "home.nav.impact": "الأثر",
    "home.nav.charities": "الجمعيات الخيرية",
    "home.nav.volunteer": "التطوع",
    "home.footer.brand.tagline":
      "تحويل العمل الخيري من خلال شفافية البلوكتشين والتمويل المستدام.",
    "home.footer.product.title": "المنتج",
    "home.footer.product.impactFunds": "صناديق الأثر",
    "home.footer.product.charities": "للجمعيات الخيرية",
    "home.footer.product.volunteers": "للمتطوعين",
    "home.footer.resources.title": "الموارد",
    "home.footer.resources.whitepaper": "الورقة البيضاء (قريبًا)",
    "home.footer.resources.blog": "المدونة (قريبًا)",
    "home.footer.resources.community": "المجتمع (قريبًا)",
    "home.footer.connect.title": "تواصل",
    "home.footer.connect.contact": "اتصل بنا (قريبًا)",
    "home.footer.copyright":
      "Give Protocol. متعدد السلاسل بالتصميم. يعمل بجهود متطوعي Give Protocol.",
    "auth.signin.welcomeBack": "مرحبًا بعودتك",
    "auth.signin.subtitle": "سجّل الدخول إلى حسابك في Give Protocol",
    "auth.signin.emailPlaceholder": "البريد الإلكتروني",
    "auth.signin.passwordPlaceholder": "كلمة المرور",
    "auth.signin.submitting": "جارٍ تسجيل الدخول…",
    "auth.signin.withPasskey": "تسجيل الدخول بمفتاح المرور",
    "auth.signin.withGoogle": "المتابعة مع Google",
    "auth.signin.or": "أو",
    "auth.signin.newToProtocol": "جديد على Give Protocol؟",
    "auth.signin.createAccount": "إنشاء حساب →",
    "auth.signin.forgotPasswordLink": "نسيت كلمة المرور؟ →",
    "auth.signin.sslEncrypted": "مشفر بتقنية TLS",
    "auth.signin.modeToggleLabel": "طريقة تسجيل الدخول",
    "auth.signin.terms": "الشروط",
    "auth.signin.privacy": "الخصوصية",
    "auth.panel.headline": "عطاء ذكي، أثر شفاف.",
    "auth.panel.subheadline":
      "حساب واحد. تبرع بالبطاقة أو العملات الرقمية. تتبع كل دولار على السلسلة.",
    "auth.panel.statusLabel": "حالة البروتوكول · مرحلة التأسيس",
    "auth.panel.statusDesc": "بناء أسس العطاء الشفاف",
    "auth.panel.runsOn": "يعمل على",
    "auth.wallet.connect": "ربط المحفظة",
    "auth.wallet.connecting": "جارٍ ربط المحفظة…",
    "auth.wallet.signing": "جارٍ توقيع الرسالة…",
    "auth.wallet.verifying": "جارٍ التحقق…",
    "auth.wallet.openingSession": "جارٍ فتح الجلسة…",
    "auth.validation.emailRequired": "يرجى إدخال بريدك الإلكتروني أولًا",
    "auth.validation.invalidEmail": "يرجى إدخال بريد إلكتروني صالح",
    "auth.validation.passwordTooShort":
      "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
    "auth.validation.passwordMismatch": "كلمتا المرور غير متطابقتين",
    "auth.login.welcomeHeading": "مرحبًا بك في Give Protocol",
    "auth.login.signInOrConnect": "تسجيل الدخول أو الاتصال",
    "auth.login.skipToContent": "تخطي إلى محتوى تسجيل الدخول",
    "auth.login.donorTitle": "تسجيل دخول المتبرع",
    "auth.login.donorSubtitle":
      "سجّل الدخول للوصول إلى لوحة التبرعات الخاصة بك",
    "auth.login.charityTitle": "بوابة المنظمات غير الربحية",
    "auth.login.charitySubtitle": "إدارة ملف منظمتك والتبرعات",
    "auth.login.back": "← رجوع",
    "auth.login.continueDonor": "المتابعة كمتبرع",
    "auth.login.connecting": "جارٍ الاتصال…",
    "auth.login.connectWalletSignIn": "ربط المحفظة وتسجيل الدخول",
    "auth.login.newToPlatform": "جديد على Give Protocol؟",
    "auth.login.newDonorSignUp": "تسجيل متبرع جديد",
    "auth.login.manageNonprofit": "أدير منظمة غير ربحية",
    "auth.login.nonprofitTrayTitle": "جديد على Give Protocol؟",
    "auth.login.createNonprofitAccount": "إنشاء حساب منظمة غير ربحية",
    "auth.login.registerOrg": "سجّل منظمتك على Give Protocol",
    "auth.login.needHelp": "تحتاج مساعدة؟",
    "auth.login.forgotUsernameBtn": "نسيت اسم المستخدم؟",
    "auth.login.forgotPasswordBtn": "نسيت كلمة المرور؟",
    "auth.donorLogin.mismatch":
      "لم يُعثر على حساب متبرع. هذا البريد الإلكتروني مسجل كحساب جمعية خيرية. يرجى استخدام بوابة تسجيل دخول الجمعيات الخيرية.",
    "auth.donorLogin.signingIn": "جارٍ تسجيل الدخول…",
    "auth.donorLogin.redirecting": "إعادة التوجيه خلال {{count}}...",
    "auth.donorReg.pleaseWait": "يرجى الانتظار…",
    "auth.donorReg.signUpPasskey": "التسجيل بمفتاح المرور",
    "auth.donorReg.withGoogle": "المتابعة مع Google",
    "auth.donorReg.connectWallet": "ربط المحفظة",
    "auth.donorReg.orSetPassword": "أو قم بتعيين كلمة مرور",
    "auth.donorReg.creating": "جارٍ إنشاء الحساب...",
    "auth.donorReg.createAccount": "إنشاء حساب متبرع",
    "auth.donorReg.privacyNotice": "بإنشاء حساب، فإنك توافق على",
    "auth.donorReg.termsLink": "شروط الخدمة",
    "auth.donorReg.privacyAnd": "وتقر بـ",
    "auth.donorReg.privacyLink": "سياسة الخصوصية",
    "auth.charityLogin.mismatch":
      "هذا البريد الإلكتروني مسجل كحساب متبرع. يرجى تسجيل الدخول من بوابة المتبرعين.",
    "auth.charityLogin.signingIn": "جارٍ تسجيل الدخول...",
    "auth.charityLogin.or": "أو",
    "auth.charityLogin.connecting": "جارٍ الاتصال...",
    "auth.charityLogin.connectWallet": "ربط المحفظة",
    "auth.forgot.resetPassword": "إعادة تعيين كلمة المرور",
    "auth.forgot.forgotUsername": "نسيت اسم المستخدم",
    "auth.forgot.passwordDesc":
      "أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.",
    "auth.forgot.usernameDesc":
      "أدخل بريدك الإلكتروني وسنرسل لك اسم المستخدم الخاص بك.",
    "auth.forgot.passwordSuccess":
      "تم إرسال تعليمات إعادة تعيين كلمة المرور إلى بريدك الإلكتروني",
    "auth.forgot.usernameSuccess":
      "تم إرسال تذكير باسم المستخدم إلى بريدك الإلكتروني",
    "auth.forgot.checkEmail": "تحقق من بريدك الإلكتروني",
    "auth.forgot.backToSignIn": "العودة إلى تسجيل الدخول",
    "auth.forgot.emailPlaceholder": "أدخل بريدك الإلكتروني",
    "auth.forgot.genericError": "حدث خطأ. يرجى المحاولة مرة أخرى.",
    "auth.forgot.sending": "جارٍ الإرسال...",
    "auth.forgot.sendResetLink": "إرسال رابط إعادة التعيين",
    "auth.forgot.sendUsername": "إرسال اسم المستخدم",

    // Reset password (set new password page) — pending translation (GIV-367)
    "auth.resetPassword.title": "Set New Password",
    "auth.resetPassword.subtitle": "Choose a strong password for your account.",
    "auth.resetPassword.newPassword": "New Password",
    "auth.resetPassword.confirmPassword": "Confirm New Password",
    "auth.resetPassword.submit": "Update Password",
    "auth.resetPassword.updating": "Updating\u2026",
    "auth.resetPassword.mismatch": "Passwords do not match.",
    "auth.resetPassword.success": "Password updated successfully!",
    "auth.resetPassword.successSubtitle":
      "You can now sign in with your new password.",
    "auth.resetPassword.backToSignIn": "Back to Sign In",
    "auth.resetPassword.invalidLink":
      "This password reset link is invalid or has expired.",
    "auth.resetPassword.requestNew": "Request a new reset link",
    "auth.resetPassword.validating": "Validating reset link\u2026",
    "auth.orgSearch.orgNameLabel": "اسم المنظمة",
    "auth.orgSearch.searchPlaceholder": "البحث باسم المنظمة...",
    "auth.orgSearch.countryLabel": "الدولة",
    "auth.orgSearch.allCountries": "جميع الدول",
    "auth.orgSearch.searchPrompt":
      "ابحث في قاعدة بياناتنا للعثور على منظمتك والمطالبة بها.",
    "auth.orgSearch.noResults": "لم يُعثر على منظمات.",
    "auth.orgSearch.loadMore": "تحميل المزيد من النتائج",
    "auth.orgSearch.cantFind": "لا تجد منظمتك؟",
    "auth.orgSearch.registerManually": "التسجيل يدويًا",
    "charity.claim.orgDetails": "تفاصيل المنظمة (من السجل)",
    "charity.claim.orgNameLabel": "الاسم",
    "charity.claim.einLabel": "الرقم الضريبي",
    "charity.claim.locationLabel": "الموقع",
    "charity.claim.contactInfo": "معلومات الاتصال",
    "charity.claim.contactName": "اسم جهة الاتصال",
    "charity.claim.contactEmail": "البريد الإلكتروني لجهة الاتصال",
    "charity.claim.accountSecurity": "أمان الحساب",
    "charity.claim.password": "كلمة المرور",
    "charity.claim.confirmPassword": "تأكيد كلمة المرور",
    "charity.claim.backToSearch": "العودة إلى البحث",
    "charity.claim.creating": "جارٍ إنشاء الحساب...",
    "charity.claim.submit": "المطالبة بالمنظمة",
    "charity.claim.validation.name": "يجب أن يكون الاسم بين 2 و100 حرف",
    "charity.claim.validation.email": "يرجى إدخال بريد إلكتروني صالح",
    "charity.claim.validation.password":
      "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
    "charity.claim.validation.confirmPassword": "كلمتا المرور غير متطابقتين",
    "charity.claim.validation.fix": "يرجى تصحيح أخطاء التحقق",
    "charity.claim.useAsPublicEmail":
      "استخدم بريدي الإلكتروني كبريد الاتصال العام للمنظمة",
    "charity.claim.publicContactEmail": "البريد الإلكتروني العام للمنظمة",
    "charity.claim.privacyNotice":
      "يُستخدم بريدك الإلكتروني/هاتفك الشخصي للتحقق فقط ولا يظهر لمستخدمي المنصة الآخرين. يُعرض البريد الإلكتروني العام في ملف منظمتك.",
    "charity.claim.secondContactTitle": "جهة الاتصال الثانية",
    "charity.claim.secondContactName": "اسم جهة الاتصال الثانية",
    "charity.claim.secondContactEmail": "البريد الإلكتروني لجهة الاتصال الثانية",
    "charity.claim.secondContactHint":
      "شخص مختلف يتم إخطاره عند تغيير محفظة مؤسستك الخيرية أو تفاصيل الدفع.",
    "charity.claim.validation.secondEmailDistinct":
      "يجب أن يكون البريد الإلكتروني لجهة الاتصال الثانية مختلفًا عن البريد الإلكتروني الأساسي",
    "charity.claim.error.creation": "فشل إنشاء الحساب",
    "charity.claim.error.generic": "تعذّر إنشاء الحساب",
    "charity.vetting.orgDetails": "تفاصيل المنظمة",
    "charity.vetting.orgName": "اسم المنظمة",
    "charity.vetting.description": "الوصف",
    "charity.vetting.taxId": "رقم التعريف الضريبي أو التسجيل",
    "charity.vetting.countryLabel": "الدولة",
    "charity.vetting.selectCountry": "اختر الدولة",
    "charity.vetting.address": "العنوان",
    "charity.vetting.streetAddress": "عنوان الشارع",
    "charity.vetting.city": "المدينة",
    "charity.vetting.state": "الولاية/المقاطعة",
    "charity.vetting.postalCode": "الرمز البريدي",
    "charity.vetting.contactInfo": "معلومات الاتصال",
    "charity.vetting.contactName": "اسم جهة الاتصال",
    "charity.vetting.contactEmail": "البريد الإلكتروني لجهة الاتصال",
    "charity.vetting.accountSecurity": "أمان الحساب",
    "charity.vetting.password": "كلمة المرور",
    "charity.vetting.confirmPassword": "تأكيد كلمة المرور",
    "charity.vetting.submitting": "جارٍ تقديم الطلب...",
    "charity.vetting.submit": "تقديم طلب الجمعية الخيرية",
    "charity.vetting.validation.orgName":
      "يجب أن يكون اسم المنظمة بين 2 و100 حرف",
    "charity.vetting.validation.contactName":
      "يجب أن يكون اسم جهة الاتصال بين 2 و100 حرف",
    "charity.vetting.validation.email": "يرجى إدخال بريد إلكتروني صالح",
    "charity.vetting.validation.password":
      "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
    "charity.vetting.validation.confirmPassword": "كلمتا المرور غير متطابقتين",
    "charity.vetting.validation.description": "الوصف مطلوب",
    "charity.vetting.validation.category": "الفئة مطلوبة",
    "charity.vetting.validation.taxId": "الرقم الضريبي مطلوب",
    "charity.vetting.validation.streetAddress": "عنوان الشارع مطلوب",
    "charity.vetting.validation.city": "المدينة مطلوبة",
    "charity.vetting.validation.country": "الدولة مطلوبة",
    "charity.vetting.validation.fix": "يرجى تصحيح أخطاء التحقق",
    "charity.vetting.error.generic": "تعذّر تقديم الطلب",
    "charity.vetting.privacyNotice": "بتقديم هذا الطلب، فإنك توافق على",
    "charity.vetting.termsLink": "شروط الخدمة",
    "charity.vetting.privacyAnd": "وتقر بـ",
    "charity.vetting.privacyLink": "سياسة الخصوصية",
    "common.email": "البريد الإلكتروني",
    "common.password": "كلمة المرور",
    "common.confirmPassword": "تأكيد كلمة المرور",
    "footer.brand.tagline": "إزالة الحواجز أمام العطاء الخيري المستدام.",
    "footer.resources.title": "الموارد",
    "footer.resources.faq": "الأسئلة الشائعة",
    "footer.resources.about": "من نحن",
    "footer.legal.title": "القانونية",
    "footer.legal.terms": "شروط الخدمة",
    "footer.legal.privacy": "سياسة الخصوصية",
    "footer.legal.cookiePreferences": "تفضيلات ملفات تعريف الارتباط",
    "consent.banner.ariaLabel": "الموافقة على ملفات تعريف الارتباط",
    "consent.banner.body":
      "نستخدم Google Analytics 4 (Google LLC، الولايات المتحدة) وSentry (Functional Software، الولايات المتحدة/الاتحاد الأوروبي) لفهم كيفية استخدام التطبيق واكتشاف الأخطاء. لا تتم مشاركة أي عناوين بريد إلكتروني أو عناوين محفظة أو أسماء متبرعين. يمكنك سحب موافقتك في أي وقت.",
    "consent.banner.privacyLink": "سياسة الخصوصية",
    "consent.banner.acceptAll": "قبول الكل",
    "consent.banner.decline": "رفض غير الأساسية",
    "consent.banner.customize": "تخصيص",
    "consent.modal.title": "تفضيلات ملفات تعريف الارتباط",
    "consent.modal.essentialTitle": "أساسية",
    "consent.modal.essentialDesc":
      "مطلوبة لميزات الموقع الأساسية مثل التنقل والمصادقة. لا يمكن تعطيلها.",
    "consent.modal.essentialAlwaysOn":
      "ملفات تعريف الارتباط الأساسية — مفعّلة دائمًا",
    "consent.modal.analyticsTitle":
      "التحليلات (Google Analytics 4 · الولايات المتحدة، Sentry · الولايات المتحدة/الاتحاد الأوروبي)",
    "consent.modal.analyticsDesc":
      "تساعدنا ملفات تعريف الارتباط التحليلية على فهم الصفحات التي تتم زيارتها وكيفية تنقل المستخدمين في التطبيق. نستخدم Google Analytics 4 \u2014 معرّفات الجلسات، عناوين URL للصفحات، بيانات الجهاز/المتصفح الوصفية، الموقع التقريبي من عنوان IP مجهّل الهوية (Google LLC، الولايات المتحدة؛ SCCs + EU\u2013US Data Privacy Framework). Sentry \u2014 تتبّع أخطاء مجهّل الهوية وبيانات المتصفح الوصفية لمراقبة الموثوقية (Functional Software، الاتحاد الأوروبي/الولايات المتحدة؛ آلية النقل قيد الانتظار). لا تتم مشاركة أي عناوين بريد إلكتروني أو عناوين محفظة أو أسماء متبرعين مع أي معالج بيانات.",
    "consent.modal.analyticsOn": "التحليلات وتسجيل الأخطاء — مفعّل",
    "consent.modal.analyticsOff": "التحليلات وتسجيل الأخطاء — معطّل",
    "consent.modal.cancel": "إلغاء",
    "consent.modal.save": "حفظ التفضيلات",
    "footer.connect.title": "تواصل",
    "footer.copyright": "Give Protocol. جميع الحقوق محفوظة.",
    "nav.signIn": "تسجيل الدخول",
    "nav.signOut": "تسجيل الخروج",
    "nav.privacy": "الخصوصية",
    "auth.signup.heading": "أنشئ حسابك",
    "auth.signup.subtitle": "انضم إلى حركة العطاء الشفاف",
    "auth.signup.displayName": "الاسم المعروض",
    "auth.signup.emailPlaceholder": "البريد الإلكتروني",
    "auth.signup.passwordPlaceholder": "كلمة المرور",
    "auth.signup.confirmPasswordPlaceholder": "تأكيد كلمة المرور",
    "auth.signup.submit": "إنشاء حساب",
    "auth.signup.submitting": "جارٍ إنشاء الحساب…",
    "auth.signup.withPasskey": "التسجيل بمفتاح المرور",
    "auth.signup.withGoogle": "المتابعة مع Google",
    "auth.signup.connectWallet": "ربط المحفظة",
    "auth.signup.orSetPassword": "أو قم بتعيين كلمة مرور",
    "auth.signup.alreadyHaveAccount": "لديك حساب بالفعل؟",
    "auth.signup.signInLink": "تسجيل الدخول",
    "auth.signup.manageNonprofit": "تدير منظمة غير ربحية؟",
    "auth.signup.trustText": "بياناتك محمية بموجب",
    "auth.signup.and": "و",
    "auth.signup.privacyPolicy": "سياسة الخصوصية",
    "auth.signup.panel.headline": "عطاء يمكنك التحقق منه.",
    "browse.hero.title": "عطاء موثّق على السلسلة.",
    "browse.hero.subtitle":
      "اكتشف قضايا موثّقة، وتبرّع بالبطاقة أو الأصول الرقمية، وشاهد الأثر الملموس لوقتك ومواردك.",
    "browse.stats.networks": "شبكات مدعومة",
    "browse.stats.sectors": "قطاعات خيرية",
    "browse.stats.verifiedOrgs": "منظمات معتمدة",
    "browse.stats.volunteerHours": "ساعات تطوعية",
    "browse.verified": "معتمد",
    "browse.donate": "تبرع",
    "browse.viewProfile": "عرض الملف",
    "browse.filter.ariaLabel": "تصفية الجمعيات الخيرية",
    "browse.filter.searchAria": "البحث عن جمعيات خيرية",
    "browse.filter.locationAria": "البحث عن موقع",
    "browse.results.ariaLabel": "نتائج الجمعيات الخيرية",
    "browse.tabs.charities": "الجمعيات الخيرية",
    "browse.tabs.causes": "القضايا",
    "browse.tabs.funds": "صناديق المحافظ",
    "browse.tabs.ariaLabel": "تصفح الفئات",
    "browse.featured.heading": "منظمات مميزة",
    "browse.featured.ariaLabel": "منظمات مميزة",
    "browse.featured.nextAria": "المنظمات المميزة التالية",
    "browse.causes.heading": "قضايا مميزة",
    "browse.causes.ariaLabel": "قضايا مميزة",
    "browse.causes.badge": "قضية",
    "browse.causes.raised": "تم جمعه",
    "browse.causes.percentOf": "% من",
    "browse.causes.by": "بواسطة",
    "browse.causes.supportCta": "ادعم هذه القضية",
    "browse.causes.giveCta": "تبرع",
    "browse.causes.nextAria": "القضايا المميزة التالية",
    "browse.funds.heading": "صناديق المحافظ",
    "browse.funds.ariaLabel": "صناديق المحافظ",
    "browse.funds.badge": "صندوق محفظة",
    "browse.funds.charity": "جمعية خيرية",
    "browse.funds.charities": "جمعيات خيرية",
    "browse.funds.donateCta": "التبرع للصندوق",
    "browse.funds.nextAria": "صناديق المحافظ التالية",
    "portfolio.notFound.title": "صندوق المحفظة غير موجود",
    "portfolio.notFound.body":
      "صندوق المحفظة الذي تبحث عنه غير موجود أو لم يعد نشطًا.",
    "portfolio.supportedOrgs": "المنظمات المدعومة",
    "browse.charity.einLabel": "الرقم الضريبي",
    "browse.charity.einDisplay": "الرقم الضريبي: {{value}}",
    "browse.charity.nteeLabel": "رمز القطاع",
    "browse.charity.deductibilityLabel": "قابلية الخصم الضريبي",
    "browse.charity.onPlatform": "على المنصة",
    "browse.charity.loading": "جارٍ التحميل…",
    "browse.charity.loadMore": "تحميل المزيد",
    "browse.filter.searchPlaceholder": "البحث عن جمعيات خيرية...",
    "browse.filter.locationPlaceholder": "مدينة أو ولاية أو بلد...",
    "browse.whyGiveProtocol.heading": "لماذا Give Protocol؟",
    "browse.whyGiveProtocol.verified.title": "منظمات غير ربحية موثقة",
    "browse.whyGiveProtocol.verified.description":
      "يتم التحقق من كل منظمة مقابل السجلات العامة قبل ظهورها على المنصة.",
    "browse.whyGiveProtocol.onchain.title": "شفافية على السلسلة",
    "browse.whyGiveProtocol.onchain.description":
      "يتم تسجيل التبرعات على البلوكتشين حتى تتمكن من تتبع تأثيرك من المحفظة إلى القضية.",
    "browse.whyGiveProtocol.volunteer.title": "امنح وقتك، ليس المال فقط",
    "browse.whyGiveProtocol.volunteer.description":
      "يتم التحقق من ساعات التطوع من قبل الجمعيات الخيرية وتُحتسب في سمعتك على البروتوكول.",
    "browse.news.heading": "أخبار المنصة",
    "admin.news.deleteConfirmBody": "سيتم حذف «{{title}}» نهائيًا. لا يمكن التراجع عن هذا الإجراء.",
    "admin.news.deleteConfirmTitle": "هل تريد حذف الخبر؟",
    "admin.news.saveFailed": "تعذّر حفظ التغييرات. يُرجى المحاولة مرة أخرى.",
    "admin.news.urlHelp": "اختياري. اتركه فارغًا لعرض الخبر بدون رابط.",
    "admin.news.urlInvalid": "أدخل عنوان https:// كاملًا أو مسارًا يبدأ بـ /.",
    "browse.carousel.error": "تعذّر تحميل هذا القسم. يُرجى تحديث الصفحة والمحاولة مرة أخرى.",
    "browse.carousel.goToPage": "الانتقال إلى الصفحة {{page}}",
    "browse.carousel.pageLabel": "الصفحة {{current}} من {{total}}",
    "browse.carousel.pause": "إيقاف التبديل التلقائي مؤقتًا",
    "browse.carousel.play": "استئناف التبديل التلقائي",
    "browse.causes.empty": "لا توجد قضايا متاحة بعد. تحقق مجددًا قريبًا!",
    "browse.causes.prevAria": "القضايا المميزة السابقة",
    "browse.causes.searchPlaceholder": "البحث عن قضايا...",
    "browse.causes.subheading": "ادعم مشاريع محددة تحقق أثرًا حقيقيًا.",
    "browse.charity.registryIdDisplay": "معرّف السجل: {{value}}",
    "browse.featured.empty": "لا توجد منظمات مميزة بعد. استخدم البحث أعلاه للعثور على جمعية خيرية.",
    "browse.featured.prevAria": "المنظمات المميزة السابقة",
    "browse.featured.subheading": "نظرة متجددة على الجمعيات الخيرية الموثّقة في Give Protocol.",
    "browse.filter.addLocation": "إضافة موقع",
    "browse.filter.impactNotice": "تصفية الموقع حسب الأثر غير متاحة بعد، لذا لا تُضيَّق النتائج حسب موقع الأثر.",
    "browse.filter.locationHint": "اضغط Enter أو اختر إضافة لتطبيق الموقع.",
    "browse.filter.minChars": "اكتب حرفين على الأقل للبحث.",
    "browse.funds.empty": "لا توجد صناديق محافظ متاحة بعد. تحقق مجددًا قريبًا!",
    "browse.funds.prevAria": "صناديق المحافظ السابقة",
    "browse.funds.searchPlaceholder": "البحث عن صناديق المحافظ...",
    "browse.funds.subheading": "محافظ تبرع مختارة توزّع التبرعات على جمعيات خيرية موثّقة.",
    "browse.registry.badge": "مسجّلة لدى {{registry}}",
    "browse.results.empty": "لا توجد منظمات تطابق هذا البحث. جرّب كلمة مختلفة أو أضف عامل تصفية للموقع.",
    "browse.results.error": "تعذّر تنفيذ البحث. يُرجى المحاولة مرة أخرى.",
    "browse.search.noMatches": "لا توجد نتائج تطابق «{{query}}».",
    "browse.category.A": "الفنون والثقافة",
    "browse.category.B": "التعليم",
    "browse.category.C": "البيئة",
    "browse.category.D": "رعاية الحيوان",
    "browse.category.E": "الصحة",
    "browse.category.F": "الصحة النفسية",
    "browse.category.G": "البحث الطبي",
    "browse.category.H": "البحث الطبي الحيوي",
    "browse.category.I": "الجريمة والقانون",
    "browse.category.J": "التوظيف",
    "browse.category.K": "الغذاء والتغذية",
    "browse.category.L": "الإسكان",
    "browse.category.M": "السلامة العامة",
    "browse.category.N": "الترفيه",
    "browse.category.O": "تنمية الشباب",
    "browse.category.P": "الخدمات الإنسانية",
    "browse.category.Q": "دولي",
    "browse.category.R": "الحقوق المدنية",
    "browse.category.S": "التنمية المجتمعية",
    "browse.category.T": "العمل الخيري",
    "browse.category.U": "العلوم والتكنولوجيا",
    "browse.category.V": "العلوم الاجتماعية",
    "browse.category.W": "السياسة العامة",
    "browse.category.X": "الدين",
    "browse.category.Y": "المنفعة المتبادلة",
    "browse.category.default": "منظمة غير ربحية",
    "cause.causes": "القضايا",
    "cause.createNew": "إنشاء جديد",
    "cause.noCausesTitle": "لا توجد قضايا بعد",
    "cause.name": "الاسم",
    "cause.description": "الوصف",
    "cause.category": "الفئة",
    "cause.targetAmount": "المبلغ المستهدف",
    "cause.headerImage": "صورة الرأسية",
    "cause.impact": "الأثر",
    "cause.impactHelp": "صف الأثر المتوقع لهذه القضية.",
    "cause.location": "الموقع",
    "cause.timeline": "الجدول الزمني",
    "cause.partners": "الشركاء",
    "cause.limitReached": "تم بلوغ الحد الأقصى للقضايا",
    "impact.statistics": "إحصائيات الأثر",
    "impact.statLabel": "التسمية",
    "impact.statValue": "القيمة",
    "impact.missionStatement": "بيان المهمة",
    "impact.missionPlaceholder": "مهمتنا هي...",
    "impact.highlights": "أبرز الإنجازات",
    "impact.highlight": "إنجاز بارز",
    "impact.addHighlight": "إضافة إنجاز",
    "impact.profile": "ملف الأثر",
    "impact.loadError": "تعذّر تحميل ملف الأثر",
    "impact.saveError": "تعذّر حفظ ملف الأثر",
    "impact.saveSuccess": "تم حفظ ملف الأثر بنجاح",
    "organization.yearFounded": "سنة التأسيس",
    "organization.address": "العنوان",
    "organization.street": "عنوان الشارع",
    "organization.city": "المدينة",
    "organization.stateProvince": "الولاية/المقاطعة",
    "organization.postalCode": "الرمز البريدي",
    "organization.country": "الدولة",
    "organization.contactInfo": "معلومات الاتصال",
    "organization.phone": "الهاتف",
    "organization.email": "البريد الإلكتروني",
    "organization.website": "الموقع الإلكتروني",
    "organization.socialMedia": "وسائل التواصل الاجتماعي",
    "organization.publicFeed": "الخلاصة العامة",
    "organization.communityMedia": "المجتمع والإعلام",
    "organization.profile": "ملف المنظمة",
    "organization.loadError": "تعذّر تحميل ملف المنظمة",
    "organization.saveError": "تعذّر حفظ ملف المنظمة",
    "common.remove": "إزالة",
    "common.saveChanges": "حفظ التغييرات",
    "dashboard.thisMonth": "هذا الشهر",
    "dashboard.verified": "متطوعون معتمدون",
    "dashboard.hoursLogged": "ساعات مسجلة",
    "dashboard.endorsements": "التزكيات",
    "dashboard.organizationsHelped": "المنظمات التي تم مساعدتها",
    "dashboard.yourOrganizationsHelped": "المنظمات التي ساعدتها",
    "transactions.createCampaign": "أنشئ حملتك الأولى",
    "contributions.emptyTitle": "رحلة عطائك تبدأ من هنا",
    "contributions.browseCharities": "تصفح الجمعيات الخيرية",
    "charity.profile.verified501c3": "مؤسسة غير ربحية معتمدة",
    "charity.profile.verified501c3Tooltip":
      "منظمة 501(c)(3) مسجّلة — قد تكون التبرعات قابلة للخصم الضريبي في الولايات المتحدة",
    "charity.profile.statusClaimed": "مُطالَب بها",
    "charity.profile.statusUnclaimed":
      "غير مُطالَب بها — بيانات السجل العام فقط",
    "charity.profile.statusIrsVerified":
      "مؤسسة غير ربحية معتمدة من مصلحة الضرائب (IRS)",
    "charity.profile.requestWidget.unclaimedBody":
      "لم تطالب هذه المنظمة بعد بملفها على Give Protocol. ستتوفر التبرعات بمجرد أن تطالب المنظمة بملفها ويكتمل إعداد المحفظة.",
    "charity.profile.rowEin": "الرقم الضريبي",
    "charity.profile.rowName": "الاسم",
    "charity.profile.rowLocation": "الموقع",
    "charity.profile.rowRulingYear": "سنة التسجيل",
    "charity.profile.rowNteeCode": "رمز القطاع",
    "charity.profile.rowDeductibility": "قابلية الخصم الضريبي",
    "charity.profile.rowAffiliation": "الانتماء",
    "charity.profile.rowClassification": "التصنيف",
    "charity.profile.rowFoundation": "نوع المؤسسة",
    "charity.profile.rowActivityCodes": "رموز النشاط",
    "charity.profile.rowOrgType": "نوع المنظمة",
    "charity.profile.rowSubsection": "القسم الفرعي",
    "charity.profile.rowStatus": "الحالة",
    "charity.profile.registryRecord": "السجل العام للمنظمة",
    "charity.profile.einDisplay": "الرقم الضريبي",
    "charity.profile.charityNotFoundByTaxId":
      "لم نتمكن من العثور على مؤسسة خيرية بهذا الرقم الضريبي.",
    "charity.profile.registeredNonprofit": "مؤسسة غير ربحية مسجّلة",
    "charity.profile.registeredYear": "مسجلة {{year}}",
    "charity.profile.shareAria": "مشاركة",
    "charity.profile.copied": "تم النسخ!",
    "charity.profile.about": "حول",
    "charity.profile.claimProfile": "المطالبة بهذا الملف",
    "charity.profile.noDescription": "لا يوجد وصف متاح.",
    "charity.profile.toAddOne": "لإضافة وصف.",
    "charity.profile.contact": "الاتصال",
    "charity.profile.donate.support": "دعم",
    "charity.profile.donate.walletUnset":
      "لم تقم هذه المنظمة بعد بإعداد محفظة استلام رسمية.",
    "charity.profile.donate.walletPending":
      "هذه المنظمة تُكمل إعداد محفظتها — التبرعات غير متاحة مؤقتاً.",
    "charity.profile.donate.walletLegacy":
      "تستخدم هذه المنظمة عنوان محفظة قديم.",
    "charity.profile.donate.feeNote":
      "رسوم منصة 0% على التبرعات المباشرة. تُطبَّق رسوم الشبكة.",
    "charity.profile.donate.jurisdictionUnavailable":
      "التبرعات للمنظمات الخيرية خارج الولايات المتحدة ليست متاحة بعد على Give Protocol.",
    "portfolio.title": "صناديق المحافظ",
    "settings.displayPreferences": "تفضيلات العرض",
    "settings.theme": "المظهر",
    "settings.light": "فاتح",
    "settings.dark": "داكن",
    "auth.toast.welcomeBack": "Welcome back, {{firstName}}",
    "auth.toast.youreSignedIn": "You're signed in.",
    "auth.toast.walletConnected": "Wallet connected",
    "auth.toast.signedInWith": "Signed in with {{address}}.",
    "auth.toast.signedOut": "Signed out",
    "auth.toast.signInFailed": "Sign-in failed",
    "auth.toast.signOutFailed": "Sign-out failed",
    "donation.toast.received": "Donation received",
    "donation.toast.receivedMessage":
      "Thank you — your tax receipt is on the way.",
    "donation.toast.submitted": "Transaction submitted",
    "donation.toast.submittedMessage": "Waiting for on-chain confirmation…",
    "donation.toast.confirmed": "Donation confirmed",
    "donation.toast.confirmedMessage":
      "Your contribution is recorded on-chain.",
    "donation.toast.failed": "Donation failed",

    // Art. 9(2)(a) donation consent (GIV-655)
    "donation.art9Consent.statement":
      "أفهم أن سجل تبرعي يربطني بـ {{charity}}. حيث قد يشير ذلك إلى انتماء ديني أو سياسي أو فلسفي، فإنني أوافق صراحةً على معالجة Give Protocol لهذا السجل لإتمام تبرعي وإدارته.",
    "donation.art9Consent.label": "الموافقة على بيانات التبرع",
    "donation.art9Consent.required":
      "يجب أن توافق على معالجة بيانات التبرع للمتابعة.",

    "charity.toast.verificationEmailSent": "Verification email sent",
    "charity.toast.verificationEmailMessage":
      "Check your inbox — the link expires in 24 hours.",
    "charity.toast.submissionFailed": "Submission failed",

    "privacy.security.auditLog":
      "كإجراء تقني بموجب المادة 32 من اللائحة العامة لحماية البيانات (GDPR)، نقوم بتسجيل ومراقبة الوصول الإداري إلى البيانات الشخصية — بما في ذلك الإجراء المتخذ ووقت حدوثه — للكشف عن الوصول غير المصرح به، وإثبات المساءلة، وإعادة بناء الأحداث في حالة حدوث انتهاك غير محتمل للبيانات الشخصية (المادة 34). لا يتم نسخ البيانات الشخصية للمتبرعين في سجلات الوصول الإداري هذه. تختلف سجلات الوصول الإداري عن سجلات المصادقة والأمان الموصوفة في §7.1؛ وتخضع فترة الاحتفاظ بها لسجل أنشطة المعالجة الداخلي لدينا.",

    // Remaining i18n keys — batch translation
    "admin.auditTrail.filterByAction": "تصفية حسب الإجراء",
    "admin.auditTrail.allActions": "جميع الإجراءات",
    "admin.auditTrail.action.charityStatusChange": "تغيير حالة الجمعية الخيرية",
    "admin.auditTrail.action.userStatusChange": "تغيير حالة المستخدم",
    "admin.auditTrail.action.donationFlag": "الإبلاغ عن تبرع",
    "admin.auditTrail.action.donationFlagResolve": "حل الإبلاغ عن تبرع",
    "admin.auditTrail.action.validationOverride": "تجاوز التحقق",
    "admin.auditTrail.action.configChange": "تغيير الإعدادات",
    "admin.auditTrail.action.verificationApprove": "الموافقة على التحقق",
    "admin.auditTrail.action.verificationReject": "رفض التحقق",
    "admin.auditTrail.action.charitySuspend": "تعليق الجمعية الخيرية",
    "admin.auditTrail.action.charityReinstate": "إعادة تفعيل الجمعية الخيرية",
    "admin.auditTrail.action.userSuspend": "تعليق المستخدم",
    "admin.auditTrail.action.userReinstate": "إعادة تفعيل المستخدم",
    "admin.auditTrail.action.userBan": "حظر المستخدم",
    "admin.auditTrail.action.viewPii": "عرض البيانات الشخصية",
    "admin.auditTrail.action.viewPiiList": "عرض قائمة البيانات الشخصية",
    "admin.auditTrail.viewedEntity":
      "قام المسؤول {{adminId}} بعرض {{entityType}} {{entityId}}",
    "admin.auditTrail.viewedList":
      "قام المسؤول {{adminId}} بعرض قائمة {{entityType}} (الصفحة {{page}}، المرشحات: {{filters}})",
    "admin.auditTrail.viewedListNoFilters":
      "قام المسؤول {{adminId}} بعرض قائمة {{entityType}} (الصفحة {{page}})",
    "admin.actions.platformNews": "أخبار المنصة",
    "admin.actions.platformNewsDesc": "إدارة عناصر الأخبار في صفحة التصفح",
    "admin.news.activate": "تفعيل {{title}}",
    "admin.news.activated": "تم نشر عنصر الأخبار",
    "admin.news.activeLabel": "منشور (مرئي للجمهور)",
    "admin.news.categoryLabel": "الفئة",
    "admin.news.contentLabel": "المحتوى / المقتطف",
    "admin.news.contentPlaceholder": "وصف موجز لعنصر الأخبار...",
    "admin.news.createNews": "إنشاء عنصر أخبار",
    "admin.news.createNewsBtn": "إنشاء خبر",
    "admin.news.created": "تم إنشاء عنصر الأخبار",
    "admin.news.dateLabel": "تاريخ النشر",
    "admin.news.deactivate": "إلغاء تفعيل {{title}}",
    "admin.news.deactivated": "تم إخفاء عنصر الأخبار",
    "admin.news.deleteItem": "حذف {{title}}",
    "admin.news.deleted": "تم حذف عنصر الأخبار",
    "admin.news.editItem": "تعديل {{title}}",
    "admin.news.editNews": "تعديل عنصر الأخبار",
    "admin.news.imageLabel": "رابط الصورة (اختياري)",
    "admin.news.imagePlaceholder": "https://...",
    "admin.news.inactive": "غير نشط",
    "admin.news.newItem": "عنصر جديد",
    "admin.news.noItemsMessage":
      "أنشئ أول عنصر أخبار لمشاركة التحديثات مع مجتمعك",
    "admin.news.noItemsYet": "لا توجد عناصر أخبار بعد",
    "admin.news.publishedOn": "نُشر في {{date}}",
    "admin.news.saving": "جارٍ الحفظ...",
    "admin.news.subtitle": "إدارة عناصر الأخبار المعروضة في صفحة التصفح العامة",
    "admin.news.title": "أخبار المنصة",
    "admin.news.titleLabel": "العنوان",
    "admin.news.titlePlaceholder": "مثال: تقرير الأثر ربع السنوي",
    "admin.news.updateNews": "تحديث الخبر",
    "admin.news.updated": "تم تحديث عنصر الأخبار",
    "admin.news.urlLabel": "رابط الصفحة",
    "admin.news.urlPlaceholder": "https://example.org/article",
    "charity.walletBadge.institutionalLabel": "محفوظة لدى {{custodianName}}",
    "charity.walletBadge.institutionalTooltip":
      "تذهب التبرعات إلى محفظة تديرها جهة أمانة مؤسسية مؤهلة.",
    "charity.walletBadge.safeLabel":
      "خزينة متعددة التوقيعات · {{threshold}} من أصل {{count}} موقّعين",
    "charity.walletBadge.safeTooltip":
      "تذهب التبرعات إلى محفظة متعددة التوقيعات تتطلب موافقات متعددة قبل إمكانية تحريك الأموال.",
    "wallet.eoa.chain": "الشبكة",
    "wallet.eoa.checkAuthorized":
      "أنا مخوَّل من قبل مؤسستي لتعيين هذه المحفظة كعنوان استلام للتبرعات الخيرية.",
    "wallet.eoa.checkRisk":
      "أدرك أن المحفظة ذات الموقّع الواحد تحمل مخاطر أعلى من المحفظة متعددة التوقيعات، وأن فقدان المفتاح الخاص يعني فقدان الأموال بشكل دائم.",
    "wallet.eoa.confirmSubtitle": "يرجى تأكيد ما يلي قبل تسجيل هذه المحفظة.",
    "wallet.eoa.confirmTitle": "التأكيد النهائي",
    "wallet.eoa.connectFirst": "يرجى توصيل محفظتك أولاً.",
    "wallet.eoa.connectWallet": "توصيل المحفظة",
    "wallet.eoa.missingSignature":
      "التوقيع مفقود. يرجى الرجوع والتوقيع مرة أخرى.",
    "wallet.eoa.proceedAnyway": "أفهم ذلك، المتابعة",
    "wallet.eoa.register": "تسجيل المحفظة",
    "wallet.eoa.registering": "جارٍ التسجيل...",
    "wallet.eoa.rejected": "تم رفض طلب التوقيع.",
    "wallet.eoa.riskParagraph1":
      "تُدار المحفظة ذات الموقّع الواحد (EOA) بواسطة مفتاح خاص واحد. في حال فقدان هذا المفتاح أو سرقته أو اختراقه، فإن جميع الأموال المرسلة إلى هذه المحفظة تصبح غير قابلة للاسترداد نهائيًا.",
    "wallet.eoa.riskParagraph2":
      "بالنسبة للأموال المؤسسية، نوصي بشدة باستخدام محفظة Safe متعددة التوقيعات بدلاً من ذلك. تتطلب المحافظ متعددة التوقيعات موافقات متعددة لكل معاملة، مما يحمي من نقاط الفشل الفردية.",
    "wallet.eoa.riskParagraph3":
      "بالمتابعة، فإنك تقر بأن Give Protocol غير مسؤول عن أي فقدان للأموال ناتج عن اختراق المفتاح الخاص أو فقدانه أو سوء إدارته.",
    "wallet.eoa.riskTitle": "محفظة ذات موقّع واحد: مخاطر مهمة",
    "wallet.eoa.signError": "فشل توقيع الرسالة. يرجى المحاولة مرة أخرى.",
    "wallet.eoa.signMessage": "توقيع رسالة التحقق",
    "wallet.eoa.signSubtitle":
      "وصّل محفظتك ووقّع رسالة لإثبات تحكمك في هذا العنوان.",
    "wallet.eoa.signTitle": "الاتصال والتوقيع",
    "wallet.eoa.useMultisig": "استخدام محفظة متعددة التوقيعات بدلاً من ذلك",
    "wallet.eoa.walletConnection": "المحفظة",
    "wallet.eoa.walletToRegister": "المحفظة المراد تسجيلها",
    "wallet.institutional.address": "عنوان المحفظة",
    "wallet.institutional.attestation": "مستند الإثبات",
    "wallet.institutional.attestationHelp":
      "قم برفع ملف PDF أو JPEG أو PNG (بحد أقصى 10 ميغابايت) يثبت علاقة الحفظ الخاصة بك.",
    "wallet.institutional.backToWallets": "العودة إلى المحافظ",
    "wallet.institutional.chain": "الشبكة",
    "wallet.institutional.chooseFile": "اختر ملفًا أو اسحبه وأفلته",
    "wallet.institutional.custodian": "جهة الحفظ",
    "wallet.institutional.fileTooLarge":
      "يجب أن يكون حجم الملف أقل من 10 ميغابايت.",
    "wallet.institutional.invalidAddress":
      "يرجى إدخال عنوان Ethereum صالح (0x...)",
    "wallet.institutional.invalidFileType":
      "يرجى رفع ملف بصيغة PDF أو JPEG أو PNG.",
    "wallet.institutional.removeFile": "إزالة الملف",
    "wallet.institutional.selectCustodian": "يرجى اختيار جهة حفظ.",
    "wallet.institutional.selectCustodianOption": "اختر جهة الحفظ...",
    "wallet.institutional.submit": "إرسال للمراجعة",
    "wallet.institutional.submittedDesc":
      "تسجيل محفظتك المؤسسية قيد المراجعة. ستتلقى رسالة بريد إلكتروني خلال 3 أيام عمل.",
    "wallet.institutional.submittedTitle": "تم إرسال المحفظة للمراجعة",
    "wallet.institutional.submitting": "جارٍ الإرسال...",
    "wallet.institutional.subtitle":
      "قدّم تفاصيل محفظتك التي تديرها جهة الحفظ وقم برفع مستند إثبات للتحقق.",
    "wallet.institutional.title": "تسجيل محفظة حفظ مؤسسية",
    "wallet.institutional.uploadFile": "رفع ملف الإثبات",
    "wallet.institutional.uploadRequired": "يرجى رفع مستند إثبات.",
    "wallet.safe.address": "عنوان Safe",
    "wallet.safe.chain": "الشبكة",
    "wallet.safe.connectFirst": "يرجى توصيل محفظة الموقّع الخاصة بك أولاً.",
    "wallet.safe.connectSigner": "توصيل محفظة الموقّع",
    "wallet.safe.createNew": "إنشاء Safe جديدة",
    "wallet.safe.createNewDesc":
      "يفتح app.safe.global حيث يمكنك إنشاء محفظة جديدة متعددة التوقيعات. عد إلى هنا بمجرد نشرها.",
    "wallet.safe.haveOne": "لدي بالفعل Safe",
    "wallet.safe.haveOneDesc":
      "أدخل عنوان Safe الخاص بك وتحقق من التحكم بتوقيع رسالة من محفظة موقّع.",
    "wallet.safe.invalidAddress": "يرجى إدخال عنوان Ethereum صالح (0x...)",
    "wallet.safe.rejected": "تم رفض طلب التوقيع.",
    "wallet.safe.signError": "فشل توقيع رسالة التحقق. يرجى المحاولة مرة أخرى.",
    "wallet.safe.signVerify": "التوقيع للتحقق من التحكم",
    "wallet.safe.signerWallet": "محفظة الموقّع",
    "wallet.safe.subtitle":
      "تتطلب محفظة Safe موافقة عدة موقّعين على كل معاملة، مما يوفر أعلى مستوى من الأمان لأموال جمعيتك الخيرية.",
    "wallet.safe.title": "إعداد محفظة Safe متعددة التوقيعات",
    "wallet.safe.verifyTitle": "التحقق من ملكية Safe",
    "wallet.safe.verifying": "جارٍ التحقق...",
    "wallet.setup.addAnother": "إضافة محفظة أخرى",
    "wallet.setup.custodian": "جهة الحفظ",
    "wallet.setup.deleteFailed": "فشلت إزالة المحفظة",
    "wallet.setup.eoaDesc":
      "محفظة قياسية تُدار بمفتاح خاص واحد. الأبسط لكن الأقل أمانًا للاستخدام المؤسسي.",
    "wallet.setup.eoaTitle": "موقّع واحد (EOA)",
    "wallet.setup.institutionalDesc":
      "تُدار بواسطة جهة حفظ مؤهلة (Fireblocks، Anchorage، إلخ). تتطلب مستند إثبات.",
    "wallet.setup.institutionalTitle": "الحفظ المؤسسي",
    "wallet.setup.makePrimary": "تعيين كأساسية",
    "wallet.setup.primary": "أساسية",
    "wallet.setup.primaryFailed": "فشل تحديث المحفظة الأساسية",
    "wallet.setup.primaryUpdated": "تم تحديث المحفظة الأساسية",
    "wallet.setup.recommended": "موصى به",
    "wallet.setup.remove": "إزالة المحفظة",
    "wallet.setup.safeDesc":
      "يتطلب عدة موقّعين لكل معاملة. أعلى مستوى أمان للأموال المؤسسية.",
    "wallet.setup.safeSigners": "الموقّعون",
    "wallet.setup.safeTitle": "محفظة Safe متعددة التوقيعات",
    "wallet.setup.subtitle":
      "اختر كيف ستستقبل جمعيتك الخيرية التبرعات بالعملات الرقمية. نوصي بمحفظة متعددة التوقيعات لأقصى درجات الأمان.",
    "wallet.setup.title": "إعداد محفظة الاستلام الخاصة بك",
    "wallet.setup.viewExplorer": "عرض في مستكشف الكتل",
    "wallet.setup.walletAdded": "تم تسجيل المحفظة بنجاح",
    "wallet.setup.walletDeleted": "تمت إزالة المحفظة",
    "wallet.setup.walletsTitle": "محافظ الاستلام",
    "admin.nav.dashboard": "لوحة التحكم",
    "admin.nav.reports": "التقارير والتحليلات",
    "admin.nav.charities": "الجمعيات الخيرية",
    "admin.nav.donations": "التبرعات",
    "admin.nav.impactMetrics": "مقاييس الأثر",
    "admin.nav.portfolioFunds": "صناديق المحفظة",
    "admin.nav.contentModeration": "إشراف المحتوى",
    "admin.nav.settings": "إعدادات النظام",
    "admin.nav.overview": "نظرة عامة",
    "admin.nav.operations": "العمليات",
    "admin.nav.consoleLabel": "لوحة تحكم المسؤول",
    "admin.shell.searchPlaceholder":
      "البحث عن المتبرعين، الجمعيات الخيرية، رقم المعاملة…",
    "admin.shell.searchLabel": "البحث في لوحة تحكم المسؤول",
    "admin.shell.notifications": "الإشعارات",
    "admin.shell.adminLabel": "مسؤول",
    "admin.shell.superAdmin": "مسؤول عام",
    "admin.shell.signOut": "تسجيل الخروج",
    "admin.shell.backToPublicSite": "العودة إلى الموقع العام",
    "admin.shell.homeLink": "الصفحة الرئيسية لـ Give Protocol",
    "admin.dashboard.severityHigh": "أولوية عالية",
    "admin.dashboard.severityMedium": "يحتاج إلى اهتمام",
    "admin.dashboard.severityLow": "للمراجعة",
    "admin.dashboard.alertOldest": "أقدم طلب تم تقديمه",
    "admin.dashboard.alertReviewHint": "مراجعة للحفاظ على سير عملية الانضمام",
    "admin.dashboard.reviewQueue": "قائمة انتظار المراجعة",
    "admin.dashboard.kpiDonorsSub": "{{count}} جديد في آخر 30 يومًا",
    "admin.dashboard.kpiPending": "{{count}} قيد الانتظار",
    "admin.dashboard.awaitingVerification": "بانتظار التحقق",
    "admin.dashboard.kpiVerifiedSub": "من أصل {{total}} إجمالي معتمد",
    "admin.dashboard.kpiVolunteersActive": "التسجيلات النشطة",
    "admin.dashboard.kpiVolunteersSub": "لا توجد تسجيلات نشطة",
    "admin.dashboard.donationVolume": "حجم التبرعات",
    "admin.dashboard.donationVolumeSub":
      "{{range}} · العملات الرقمية والنقدية مجتمعة",
    "admin.dashboard.range30d": "آخر 30 يومًا",
    "admin.dashboard.range90d": "آخر 90 يومًا",
    "admin.dashboard.rangeYtd": "منذ بداية العام",
    "admin.dashboard.volumeEmptyTitle": "لا توجد تبرعات مسجلة بعد",
    "admin.dashboard.volumeEmptySub":
      "سيظهر الحجم في الرسم البياني بمجرد تسوية أول هبة",
    "admin.dashboard.totalVolume": "الحجم الإجمالي",
    "admin.dashboard.crypto": "العملات الرقمية",
    "admin.dashboard.fiat": "العملات التقليدية",
    "admin.dashboard.activitySubtitle": "أحداث المنصة أولاً بأول",
    "admin.dashboard.viewAllActivity": "عرض جميع الأنشطة",
    "admin.dashboard.viewAllDonations": "عرض جميع التبرعات",
    "admin.charity.tabAll": "الكل",
    "admin.charity.review": "مراجعة",
    "admin.charity.colOrganization": "المؤسسة",
    "admin.charity.colRaised": "المبلغ المجمّع",
    "admin.charity.colSubmitted": "تاريخ التقديم",
    "admin.charity.searchAria": "البحث في الجمعيات الخيرية",
    "admin.charity.reviewTitle": "مراجعة {{name}}",
    "admin.charity.submittedRelative": "تم التقديم {{when}}",
    "admin.charity.contactEmail": "البريد الإلكتروني",
    "admin.charity.contactPhone": "الهاتف",
    "admin.charity.raisedUnavailable": "لا يتوفر إجمالي التبرعات",
    "admin.error.title": "خطأ في تحميل البيانات",
    "admin.error.recentActivity": "خطأ في تحميل الأنشطة الأخيرة",
    "admin.error.alerts": "خطأ في تحميل التنبيهات",
    "admin.error.donationVolume": "خطأ في تحميل حجم التبرعات",
    "donation.gas.estimating": "جارٍ تقدير رسوم الشبكة…",
    "donation.gas.label": "رسوم الشبكة المقدّرة",
    "donation.gas.highGasWarning":
      "تنبيه ارتفاع رسوم الغاز: الرسوم المقدّرة هي {{usd}}، أي ما يعادل {{pct}} من تبرعك.",
    "donation.gas.highGasSuggestion":
      "فكّر في تبرع أكبر أو التحويل إلى شبكة ذات رسوم أقل.",
    "donation.gas.l2Hint": "لخفض الرسوم، جرّب {{chains}}.",
  },
};
